window.setupProductPageSlider = function() {  
  let selector = '.product-images-slider';
  let element = document.querySelector(selector);
  var swiper= Swiper;
  if (element) {

    function initSwiper() {
        if (window.innerWidth < 768) {
    var swiper = new Swiper('.product-images-slider', {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
    }
    else 
    {
      if (swiper) 
      {
        swiper.destroy(true, true);
        swiper = undefined;
        document.querySelector('.swiper-wrapper').style.transform = ''; // Reset any transform style
      }
    }
  }

    // Initialize Swiper on page load
    initSwiper();

    // Reinitialize Swiper on window resize
    window.addEventListener('resize', function() {
        initSwiper();
    });
   
    
    function observeSliderImages() {
      function handleIntersection(entries, observer) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target;
            if (typeof element.querySelector(".A-B-images .swiper-slide-active img").dataset.src !== "undefined") {
              element.querySelector(".A-B-images .swiper-slide-active img").src = element.querySelector(".A-B-images .swiper-slide-active img").dataset.src;
              element.querySelector(".A-B-images .swiper-slide-active img").classList.remove("hidden");
            }
          }
        });
      }
      const observerElement = new IntersectionObserver(handleIntersection, {
        root: null,
        threshold: 0
      });
      const elements = document.querySelectorAll(".grid__item product-grid-item");
      elements.forEach(element => {
        observerElement.observe(element);
      });

      function handleIntersection2(entries, observer2) {
        entries.forEach((entry) => {
          const activeSlide = entry.target;
          const imgElement = activeSlide.querySelector('img');
          if (imgElement && activeSlide.classList.contains('swiper-slide-active')) {
            imgElement.src = imgElement.dataset.src;
            imgElement.classList.remove("hidden");
          }
        });
      }

      const observer2 = new IntersectionObserver(handleIntersection2, {
        root: null,
        threshold: 0.5,
      });
      
      const allSlides = document.querySelectorAll('.swiper-slide');

      allSlides.forEach((slide) => {
        observer2.observe(slide);
      });
    }

    function checkImages() {
      var imagesElement = document.querySelector('.product-images-slider');
      if ((getComputedStyle(imagesElement).display === 'block' || imagesElement.style.display === 'block')) {
        observeSliderImages();
        document.querySelectorAll('.product-images-slider').forEach(function(elm) {
          elm.classList.add('active');
        });
      }
    }
    if (document.querySelectorAll('.product-images-slider').length > 0) {
      checkImages();
    }
  }
}

window.setupProductPageSlider();

window.addEventListener('load', function() {
  document.querySelectorAll("ul#product-grid img").forEach(el => {
    if (el.src == "") {
      el.src = el.dataset.src;
    }
  })
});

const SB025DV1 = {
  init: function () {
    this.mainCSS();
    this.mainJS();
  },
  mainCSS: function () {
    const styles = document.createElement("style");
    styles.setAttribute("type", "text/css");
    document.head.appendChild(styles).textContent = `
    .sticky {
        position: sticky !important;
        top: 0px !important;
    }
    .facets-vertical .facets-wrapper {
        top: 105px !important;
    }
                                      `;
  },
  mainJS: function () {
    document.querySelector("body").classList.add("sb025dm");
    window.addEventListener("scroll", scrollHeader);

    var header = document.querySelector(".header");
    var announcementBar = document.querySelector("#shopify-section-announcement-bar");

    var sticky = header.offsetTop;

    function getStickyOffset() {
      return announcementBar ? announcementBar.offsetHeight : 0;
    }

    function scrollHeader() {
      const offset = getStickyOffset();
      if (window.scrollY > offset) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
  },
};

(function SB025DV1PollFor() {
  if (
    document.querySelector(".header") &&
    !document.querySelector(".sb025dm")
  ) {
    console.log("SB025DV1 - Variation - 1.1");
    SB025DV1.init();
  } else {
    setTimeout(SB025DV1PollFor, 25);
  }
})();



const SB017DV1 = {
  init: function () {
    this.mainCSS();
    this.mainJS();
  },
  mainCSS: function () {
    const styles = document.createElement("style");
    styles.setAttribute("type", "text/css");
    document.head.appendChild(styles).textContent = `
    .xt-icon-text {
        margin-top: 0 !important;
    }
    #protein-li {
        height: 64px;
    }
    .protein-link {
        margin-top: 20px;
    }
    #protein-li > div {
        height: 100%;
        display: flex;
        height: fit-content;
        width: 82%;
    }
    .ch-ps {
        white-space: pre-wrap;
    }
    #Nitrate {
        width: 100%;
        display: block;
        line-height: 130%;
    }
    #Nitrate > strong {
        margin-right: 3px;
    }
    .net-wt-wrap {
       display: flex;
    }
    .net-wt-wrap > .cc-reg {
        margin-right: 3px;
    }
    .scoops {
        display: flex;
    }
    .compare-container {
        display: flex;
        padding: 0 25px 20px 25px;
        justify-content: center;
        align-items: center;
        gap: 15px;
        align-self: stretch;
    }
    .compare-link {
        color: #1680C7;
        font-family: FONTSPRING DEMO - Aftika Bold;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px; /* 150% */
        text-decoration-line: underline
    }
    .compare-img {
        height: 134px;
        width: 236px;
    }
    .compare-chart-container {
        display: flex;
        width: 100%;
        padding: 50px 48px;
        flex-direction: column;
        align-items: center;
        background: #F6F9FC;
    }
    .compare-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
    }
    .compare-title h1 {
        color: #000;
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%; /* 33.6px */
        text-transform: uppercase;
    }
    .cc-inner {
        display: flex;
        border-radius: 10px 0px 0px 10px;
    }
    .compare-card {
        display: flex;
        flex-direction: column;
        padding: 16px 16px 20px 16px;
        background: #fff;
        border-right: 1px solid #f0f0f0;
        width: 230px;
    }
    .compare-card-p {
        display: flex;
        flex-direction: column;
        padding: 16px 16px 20px 16px;
        background: #fff;
        border-right: 1px solid #f0f0f0;
        width: 269px;
        position: relative;
    }
    .stars {
        display: flex;
        margin-right: 12px;
    }
    .stars svg {
        width: 12.003px;
        height: 12px;
    }
    .compare-review p {
        color: #000;
        font-family: Aftika;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
    }
    .cc-product-title {
        color: #1E1E1E;
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 18.2px */
        text-transform: uppercase;
        width: 192px;
        height: 37px;
        white-space: pre-wrap;
    }
    .cc-bold {
        font-weight: 700 !important;
        margin-right: 3px;
    }
    .cc-details ul li span {
        color: #6C787C;
        font-family: Aftika;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
        display: block;
    }
    .bestsell-tag {
        border-radius: 4px;
        background: #FF5D0D;
        display: flex;
        padding: 4px 4px 2px 4px;
        justify-content: center;
        align-items: center;
        width: 70px;
        position: absolute;
    }
    .bestsell-tag span {
        color: #FFF;
        font-family: Aftika;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 14.4px */
    }
    .compare-card a span, .cc-inner a span {
        color: #40B5E8;
        text-align: right;
        font-family: Aftika;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 200% */
        margin-right: 4px;
    }
    .compare-card a, .cc-inner a {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .compare-review {
        display: flex;
        align-items: center;
        margin-top: 12px;
        margin-bottom: 8px;
    }
    .cc-details li {
        padding: 8px 0;
        height: 40px;
        border-bottom: 1px solid #F0F0F0;
        display: flex;
        align-items: center;
    }
    #last {
        height: 70px;
        flex-wrap: unset;
    }
    #last-p {
        height: 60px;
        flex-wrap: unset;
    }
    #last-p > div > div {
        display: flex;
    }
    #cc-bold {
        margin-left: 3px;
    }
    .cc-details ul {
        height: 249px;
    }
    #pre-list {
        height: 310px;
    }
    #lh-adjust, #lh-adjust-2 {
        color: #6C787C;
        font-family: Aftika;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 130%;
    }
    .cc-details li p {
        width: 100%;
        display: flex;
    }
    #ingred-list {
        height: 100px;
        flex-wrap: unset;
        justify-content: flex-start;
        align-items: center;
    }
    .cc-details > ul > li > svg {
      margin-right: 10px;
      width: 15%;
  }
  .details {
      justify-content: space-between;
      flex-wrap: unset !important;
      height: 80px !important;
  }
  .details-p {
    flex-wrap: unset !important;
    height: 48px !important;
    justify-content: space-between;
}
.details-p .cc-reg {
    width: 86%;
    white-space: pre-wrap;
}
  .details span {
      width: 86%;
  }
    @media (max-width: 1285px) {
        .compare-card {
            width: 210px;
        }
        .compare-card-p {
            width: 249px;
        }
        .cc-details ul li span {
            font-size: 11px;
        }
        .cc-details > ul > li > svg {
          margin-right: 4px;
        }
    }
    @media (max-width: 1040px) {
        .compare-chart-wrap {
            overflow: auto;
            white-space: nowrap;
            width: 100%;
            border-radius: 10px;
        }
        .cc-product-title {
            text-wrap: wrap;
        }
        .cc-inner {
            width: 1226px;
            border-radius: 10px;
        }
        .cc-reg {
            text-wrap: wrap;
        }
        .compare-card {
            width: 214px;
        }
    }
    @media (max-width: 600px) {
        .compare-chart-container {
            padding: 50px 20px;
        }
        .compare-card a, .cc-inner a {
            margin-top: 16px;
        }
        .cc-inner {
            width: 1245px;
        }
        .compare-title h1 {
            font-size: 20px;
        }
        .cc-details ul li span {
            font-size: 12px;
            white-space: pre-wrap;
        }
        .compare-card {
            width: 235px;
        }
        .compare-img {
            width: 100%;
            height: 134px;
        }
    }
                                    `;
  },
  mainJS: function () {
    const preSeries = [
      "/preseries-bulk-preworkout",
      "/preseries-lean-pre-workout",
      "/preseries-stim-free-preworkout",
      "/preseries-bulk-black",
      "/preseries-pump",
      "/stim-booster",
      "/bulk-pre-workout-previous-formulation",
      "/lean-pre-workout-previous-formulations",
    ];
    const proteinSeries = [
      "/proteinseries-100-grass-fed-whey-protein-isolate",
      "/proteinseries-mass-gainer",
      "/grass-fed-whey-protein-isolate-4lbs",
      "/protein-bars",
      "/protein-series-organic-vegan",
      "/proteinseries-100-grass-fed-casein-protein",
      "/proteinseries-collagen-hydrolysate",
    ];
    const compareBtn = `<div class="compare-container"><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.2937 5.12363H1.34525C0.979012 5.12363 0.658554 4.82607 0.658554 4.43694C0.658554 4.0707 0.956122 3.75024 1.34525 3.75024H13.2709C13.6371 3.75024 13.9576 4.04781 13.9576 4.43694C13.9576 4.80318 13.66 5.12363 13.2937 5.12363Z" fill="#1680C7"/>
    <path d="M4.6185 8.37411C4.43538 8.37411 4.27515 8.30544 4.13781 8.1681L0.864561 4.91774C0.612773 4.64306 0.612773 4.23104 0.864561 3.95637L4.11492 0.706009C4.3896 0.43133 4.80161 0.43133 5.07629 0.706009C5.35097 0.980687 5.35097 1.3927 5.07629 1.66738L2.30662 4.43705L5.09918 7.20672C5.35097 7.4814 5.35097 7.89342 5.09918 8.1681C4.96184 8.30544 4.77872 8.37411 4.6185 8.37411Z" fill="#1680C7"/>
    <path d="M15.9947 13.2496H4.06914C3.7029 13.2496 3.38245 12.952 3.38245 12.5629C3.38245 12.1967 3.68001 11.8762 4.06914 11.8762H15.9947C16.361 11.8762 16.6814 12.1738 16.6814 12.5629C16.6814 12.952 16.3839 13.2496 15.9947 13.2496Z" fill="#1680C7"/>
    <path d="M12.7444 16.5001C12.5613 16.5001 12.401 16.4314 12.2637 16.2941C12.0119 16.0194 12.0119 15.6074 12.2637 15.3327L15.0562 12.563L12.2637 9.79336C11.989 9.51868 11.989 9.10666 12.2637 8.83199C12.5384 8.55731 12.9504 8.55731 13.2251 8.83199L16.4754 12.0823C16.7272 12.357 16.7272 12.769 16.4754 13.0437L13.2251 16.317C13.0877 16.4314 12.9275 16.5001 12.7444 16.5001Z" fill="#1680C7"/>
    </svg>
    <a class="compare-link" href="#compareChart">Compare</a>
    </div>`;

    const comparisonBTN = document.querySelector(".comparison-btn");
    if(comparisonBTN !== null && typeof comparisonBTN !== 'undefined' )
    {
      comparisonBTN.insertAdjacentHTML("afterend", compareBtn);
    }
    
    const shopSvg = `<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_38_77)">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.537 2.80811C10.5684 2.73188 10.6182 2.6646 10.6819 2.61225C10.7455 2.5599 10.8212 2.52412 10.9021 2.50808C10.9829 2.49205 11.0665 2.49626 11.1454 2.52034C11.2242 2.54442 11.2959 2.58763 11.354 2.64611L15.354 6.64611C15.4006 6.69256 15.4375 6.74773 15.4627 6.80848C15.4879 6.86922 15.5009 6.93435 15.5009 7.00011C15.5009 7.06588 15.4879 7.131 15.4627 7.19175C15.4375 7.25249 15.4006 7.30767 15.354 7.35411L11.354 11.3541C11.2601 11.448 11.1328 11.5007 11 11.5007C10.8672 11.5007 10.7399 11.448 10.646 11.3541C10.5521 11.2602 10.4994 11.1329 10.4994 11.0001C10.4994 10.8673 10.5521 10.74 10.646 10.6461L13.793 7.50011H3C2.86739 7.50011 2.74021 7.44743 2.64645 7.35367C2.55268 7.2599 2.5 7.13272 2.5 7.00011C2.5 6.8675 2.55268 6.74033 2.64645 6.64656C2.74021 6.55279 2.86739 6.50011 3 6.50011H13.793L10.646 3.35411C10.5757 3.28416 10.5279 3.19491 10.5085 3.09769C10.4891 3.00047 10.499 2.89967 10.537 2.80811Z" fill="#40B5E8"/>
      </g>
      <defs>
      <clipPath id="clip0_38_77">
      <rect width="14" height="10" fill="white" transform="translate(2 2)"/>
      </clipPath>
      </defs>
      </svg>
      `;
    const reviewStars = `
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.49754 4.99935H0.0019989L3.74452 7.95697L2.24982 12.499L6.00594 9.69818L9.75071 12.499L8.26257 7.9174L12.0055 4.99935H7.50992L6.00087 0.499023L4.49754 4.99935Z" fill="#FD6A4C"/>
  </svg>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.49754 4.99935H0.0019989L3.74452 7.95697L2.24982 12.499L6.00594 9.69818L9.75071 12.499L8.26257 7.9174L12.0055 4.99935H7.50992L6.00087 0.499023L4.49754 4.99935Z" fill="#FD6A4C"/>
  </svg>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.49754 4.99935H0.0019989L3.74452 7.95697L2.24982 12.499L6.00594 9.69818L9.75071 12.499L8.26257 7.9174L12.0055 4.99935H7.50992L6.00087 0.499023L4.49754 4.99935Z" fill="#FD6A4C"/>
  </svg>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.49754 4.99935H0.0019989L3.74452 7.95697L2.24982 12.499L6.00594 9.69818L9.75071 12.499L8.26257 7.9174L12.0055 4.99935H7.50992L6.00087 0.499023L4.49754 4.99935Z" fill="#FD6A4C"/>
  </svg>
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.0262 4.99852H7.53066L6.02186 0.498535L4.51896 4.99852H0.0218811L3.76596 7.95679L2.27037 12.4985L6.01886 9.70362L6.02765 9.69777L9.77182 12.4985L8.28354 7.91727L12.0262 4.99852ZM8.31432 10.4858L6.02955 8.747L6.02405 8.75286V3.41354L6.97692 5.74847H9.77179L7.38558 7.57002L8.31432 10.4858Z" fill="#FD6A4C"/>
  </svg>
      `;
    let flavorIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.6247 11.8657L12.2526 4.15431C12.2011 4.05763 12.1049 4 12 4C11.895 4 11.7988 4.05762 11.7492 4.15037L7.37352 11.8691C6.88012 12.7002 6.62012 13.6489 6.62012 14.6172C6.62009 17.585 9.0334 20 12 20C14.9665 20 17.3798 17.585 17.3798 14.6172C17.3798 13.647 17.1186 12.6963 16.6247 11.8657ZM15.4021 18.02C14.9599 18.4629 14.4455 18.8101 13.8727 19.0527C13.2802 19.3037 12.6501 19.4302 11.9999 19.4302C11.3498 19.4302 10.7196 19.3037 10.1274 19.0527C9.55437 18.8101 9.03996 18.4629 8.59784 18.02C8.15571 17.5781 7.80852 17.0635 7.56659 16.4897C7.31587 15.8975 7.18865 15.2666 7.18865 14.6172C7.18865 13.7519 7.42109 12.9033 7.86077 12.1631L12 4.86181L16.1281 12.1436C16.5779 12.8989 16.8112 13.75 16.8112 14.6172C16.8112 15.2666 16.6841 15.8975 16.4333 16.4902C16.1914 17.0635 15.8442 17.5786 15.4021 18.02Z" fill="#6C787C"/>
    <path d="M12.0153 17.5766H11.9983C11.2075 17.5761 10.4646 17.2686 9.90644 16.7095C9.3476 16.1514 9.03976 15.4077 9.03976 14.6172C9.03976 14.46 8.91232 14.3325 8.75557 14.3325C8.5986 14.3325 8.47113 14.46 8.47113 14.6172C8.47113 16.5625 10.0534 18.146 11.9982 18.146H12C12.1569 18.146 12.2844 18.0181 12.2844 17.8608C12.2844 17.7095 12.165 17.5845 12.0153 17.5766Z" fill="#6C787C"/>
    </svg>
    `;
    let proteinIcon = `<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9428 4.0101C17.8997 4.02241 17.594 4.31584 16.9723 4.93757C16.133 5.77681 16.0612 5.85478 16.051 5.92865C16.0428 5.99637 16.0776 6.10307 16.2664 6.59348C16.5742 7.39373 16.9743 8.4279 17.0277 8.56127C17.0523 8.62078 17.0687 8.67823 17.0667 8.68849C17.0626 8.6967 16.5619 8.51203 15.9525 8.274C14.7275 7.80001 14.6515 7.77744 14.3807 7.81848C14.2904 7.83284 14.1714 7.87183 14.077 7.91697C13.9293 7.99084 13.8739 8.04008 12.9341 8.98192C12.0415 9.87656 11.943 9.98121 11.8856 10.1023C11.7768 10.3321 11.7501 10.5701 11.8035 10.7999C11.8178 10.8615 11.9327 11.1754 12.06 11.4976C12.5771 12.8231 12.6776 13.0858 12.6694 13.094C12.6612 13.1022 12.2487 12.9442 10.8227 12.3861C10.3671 12.2075 10.2091 12.1768 9.97316 12.2158C9.88698 12.2301 9.76181 12.2712 9.67768 12.3122C9.54225 12.3799 9.45607 12.4579 8.5799 13.332C8.03614 13.8737 7.59497 14.3292 7.54983 14.399C7.43903 14.5611 7.38568 14.7437 7.38568 14.953C7.38568 15.1664 7.40415 15.228 7.62781 15.7964C7.92123 16.5453 8.00536 16.7731 7.99305 16.7854C7.98279 16.7977 7.7263 16.7013 6.55465 16.2478C6.28379 16.1431 6.04167 16.0508 6.01499 16.0426C5.90624 16.0118 5.84879 16.0611 4.91721 16.9926L4 17.9119V18.0042C4 18.1089 4.04719 18.1889 4.13953 18.2361C4.17031 18.2525 4.35293 18.3243 4.54376 18.3982C4.73664 18.4721 5.2291 18.6629 5.64154 18.823C6.05398 18.983 6.63467 19.2087 6.93425 19.3257C7.23384 19.4406 7.68526 19.6171 7.9397 19.7155C8.54502 19.9515 8.60247 19.97 8.76047 19.9926C8.94309 20.0192 9.14828 19.9741 9.37399 19.8592C9.5443 19.773 9.57508 19.7443 10.2809 19.0343C10.7201 18.5931 11.034 18.2607 11.0689 18.2012C11.1961 17.9796 11.2412 17.641 11.1735 17.3969C11.1489 17.3045 10.9232 16.7177 10.4636 15.5501C10.3753 15.3244 10.3076 15.1377 10.3158 15.1336C10.3302 15.1295 10.7242 15.2813 11.9902 15.7738C12.616 16.018 12.7002 16.0405 12.9156 16.0262C13.1064 16.0139 13.2624 15.9605 13.4307 15.8497C13.5045 15.8005 13.917 15.4024 14.4874 14.8299C15.3492 13.964 15.4292 13.8758 15.4969 13.7403C15.616 13.4962 15.6406 13.2233 15.5647 12.975C15.5482 12.9237 15.3574 12.4292 15.142 11.8772C14.6803 10.6973 14.7028 10.7589 14.7172 10.7466C14.7234 10.7404 15.0168 10.8471 15.3718 10.9846C16.683 11.4955 16.9784 11.6043 17.1077 11.6269C17.2903 11.6556 17.5058 11.6207 17.7048 11.5263C17.8546 11.4545 17.8997 11.4114 18.8375 10.4737C19.7691 9.54209 19.8183 9.48874 19.8922 9.33895C19.9886 9.13992 20.0214 8.93472 19.9907 8.73158C19.9763 8.64335 19.8922 8.39096 19.7588 8.04829C18.2137 4.05729 18.2404 4.12706 18.2014 4.08397C18.1398 4.0101 18.0372 3.98343 17.9428 4.0101ZM18.0742 5.12224C18.1562 5.3377 18.3081 5.72756 18.4086 5.98816C18.5112 6.2467 18.661 6.63451 18.7431 6.84997C18.8252 7.06337 19.0242 7.57635 19.1843 7.98879C19.3853 8.50587 19.4777 8.77262 19.4859 8.8506C19.5064 9.06194 19.4777 9.10093 18.8354 9.74318C18.5194 10.0571 18.2588 10.3116 18.2547 10.3075C18.2506 10.3013 18.1686 10.09 18.0701 9.83552C17.9736 9.58108 17.7643 9.03732 17.6043 8.62488C17.4442 8.21245 17.2124 7.61739 17.0913 7.30139C16.9682 6.98539 16.8081 6.5709 16.7322 6.37802L16.5988 6.0292L17.2493 5.37874C17.6084 5.01965 17.9059 4.72622 17.9121 4.72622C17.9182 4.72622 17.99 4.90474 18.0742 5.12224ZM15.183 8.52844C16.5845 9.0722 16.9928 9.22815 17.1426 9.2856C17.2329 9.32049 17.317 9.35947 17.3293 9.37178C17.3498 9.3923 17.6371 10.1187 17.7274 10.3731C17.7807 10.5291 17.7807 10.6994 17.7253 10.8143C17.6248 11.0195 17.3704 11.157 17.1631 11.1139C17.1057 11.1016 16.7876 10.9846 16.4552 10.8553C16.1228 10.7261 15.5462 10.5024 15.1727 10.3588C14.8013 10.2131 14.194 9.9771 13.8226 9.83142C13.4532 9.68778 13.1413 9.56877 13.1311 9.56877C13.0695 9.56877 13.1598 9.46617 13.6605 8.96961C14.0955 8.5346 14.233 8.41148 14.3212 8.36839C14.5018 8.28221 14.59 8.29863 15.183 8.52844ZM13.5209 10.2664L14.0462 10.4737L14.274 11.0626C14.3992 11.3868 14.6105 11.9285 14.7418 12.2671C15.0886 13.1555 15.1071 13.2109 15.0948 13.3258C15.0886 13.3812 15.0681 13.4551 15.0496 13.4921C15.0291 13.529 14.7562 13.8204 14.4381 14.1384L13.8616 14.7171L13.8021 14.5591C13.7097 14.3169 13.1495 12.8765 12.9567 12.3799C12.2487 10.5681 12.2898 10.683 12.2898 10.5557C12.2898 10.2439 12.6058 9.98736 12.9156 10.0428C12.9608 10.051 13.2337 10.1515 13.5209 10.2664ZM11.0504 13.0283C11.4793 13.1945 12.0723 13.4243 12.3698 13.5413C12.6673 13.6562 12.9197 13.7609 12.93 13.7711C12.9402 13.7814 13.0428 14.0256 13.1557 14.3108C13.3835 14.8935 13.4081 15.0002 13.3465 15.1644C13.2973 15.2936 13.1721 15.4229 13.0449 15.4783C12.8889 15.546 12.774 15.5276 12.3924 15.3798C11.231 14.9284 10.638 14.6986 10.361 14.5919C9.63869 14.3149 8.72969 13.9537 8.71533 13.9414C8.69276 13.9209 9.80285 12.8231 9.88903 12.78C10.1086 12.6672 10.1435 12.6754 11.0504 13.0283ZM9.11956 14.6596L9.651 14.873L9.79669 15.2526C9.87877 15.4619 10.1127 16.0652 10.3179 16.5946C10.6421 17.4235 10.6934 17.5713 10.6954 17.6718C10.6975 17.877 10.6647 17.9181 10.0388 18.5418L9.46633 19.1123L9.37605 18.8804C9.32885 18.7532 9.1093 18.1869 8.88974 17.6226C8.51219 16.6541 8.22697 15.9236 7.9992 15.3306C7.85352 14.953 7.86583 14.7786 8.04435 14.6001C8.16541 14.477 8.28647 14.4298 8.46294 14.44C8.56348 14.4441 8.6866 14.4872 9.11956 14.6596ZM6.35561 16.7218C6.52182 16.7854 6.93836 16.9454 7.28308 17.0788C7.62781 17.2101 7.991 17.3497 8.09154 17.3887L8.27621 17.4584L8.41369 17.8175C8.48961 18.0145 8.66198 18.4618 8.7974 18.8127C8.97387 19.2641 9.03748 19.4529 9.02106 19.4632C9.0067 19.4714 8.94309 19.4796 8.87743 19.4796C8.74816 19.4796 8.78509 19.4939 7.32412 18.9256C6.14221 18.4659 5.6005 18.2566 5.1696 18.0904C4.95004 18.0063 4.76126 17.9283 4.74895 17.9181C4.73049 17.8996 6.00063 16.6069 6.03756 16.6069C6.04782 16.6069 6.19146 16.6582 6.35561 16.7218Z" fill="#6C787C"/>
    </svg>
    `;
    let calorieIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8926 20C9.14525 20 6.27483 18.4418 6.06981 14.9973C5.90578 12.2089 7.73054 8.37482 9.4733 6.67307C9.53481 6.61157 9.63732 6.59106 9.71933 6.65257C9.80134 6.69358 9.84235 6.79609 9.80134 6.89861C9.80134 6.91911 9.35028 8.31331 10.0679 9.29745C10.1499 6.79609 12.4052 4.37674 14.025 4.00769C14.107 3.98719 14.1685 4.00769 14.23 4.0692C14.271 4.13071 14.2915 4.21272 14.271 4.27423C13.7174 5.85296 14.066 7.41118 15.3576 9.01041L15.4602 9.13343C16.4033 10.3226 18.1461 12.5164 17.9205 15.1613C17.6335 18.3393 14.6605 20 11.8926 20ZM9.26827 7.49319C7.89457 9.13343 6.31584 12.3319 6.47986 14.9563C6.68489 18.3803 9.5143 19.5899 11.8926 19.5899C14.4965 19.5899 17.2439 18.0522 17.49 15.1203C17.695 12.6394 16.0137 10.5276 15.1116 9.37947L15.0091 9.25645C13.7379 7.65722 13.3279 6.09899 13.7379 4.49976C12.2002 5.13535 10.2524 7.5342 10.4779 9.78952C10.4779 9.87154 10.4369 9.95355 10.3754 9.99455C10.2934 10.0356 10.2114 10.0151 10.1499 9.97405C9.26827 9.25645 9.20676 8.19029 9.26827 7.49319Z" fill="#6C787C"/>
    </svg>
    `;
    let carbIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1762 4.00797C13.1337 3.99558 13.0882 3.99768 13.047 4.01394C13.0058 4.0302 12.9712 4.05969 12.9486 4.09778L7.44234 13.3102C7.42259 13.3426 7.41248 13.3799 7.41318 13.4179C7.41389 13.4558 7.42538 13.4927 7.44633 13.5243C7.46727 13.556 7.49679 13.581 7.53143 13.5964C7.56607 13.6119 7.6044 13.6171 7.64192 13.6116L10.8511 13.2463L9.98095 19.7745C9.97511 19.8191 9.98448 19.8643 10.0076 19.9029C10.0306 19.9414 10.0661 19.9711 10.1081 19.987C10.1501 20.003 10.1963 20.0043 10.2391 19.9907C10.282 19.9771 10.319 19.9494 10.3442 19.9122L16.553 10.572C16.5743 10.5403 16.586 10.5031 16.5868 10.4649C16.5876 10.4267 16.5774 10.3891 16.5574 10.3565C16.5375 10.324 16.5086 10.2978 16.4742 10.2812C16.4398 10.2645 16.4013 10.2581 16.3634 10.2627L13.1303 10.6199L13.3298 4.19558C13.3284 4.15177 13.3125 4.10966 13.2848 4.07576C13.257 4.04185 13.2188 4.01803 13.1762 4.00797ZM15.9922 10.6978L10.4899 18.9622L11.2742 13.0448C11.2779 13.0165 11.2755 12.9877 11.2672 12.9604C11.2588 12.9331 11.2447 12.9079 11.2258 12.8866C11.2069 12.8652 11.1836 12.8481 11.1575 12.8365C11.1314 12.8249 11.1032 12.819 11.0746 12.8193H11.0527L7.99118 13.1685L12.8988 4.95197L12.7251 10.8395C12.725 10.8676 12.7307 10.8955 12.7421 10.9213C12.7535 10.947 12.7702 10.9701 12.7911 10.989C12.812 11.0078 12.8367 11.022 12.8635 11.0306C12.8903 11.0393 12.9187 11.0421 12.9467 11.039L15.9922 10.6978Z" fill="#6C787C"/>
    </svg>
    `;
    let weightIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.9824 4.05492C8.99527 4.35779 7.35903 5.49171 6.75698 6.97652C6.56491 7.4456 6.5132 7.7337 6.5132 8.29881C6.51689 8.71619 6.53167 8.87132 6.59446 9.09662C6.72373 9.53985 6.81607 9.76516 7.00814 10.0828L7.18543 10.3783L6.98598 10.6294C5.40883 12.6461 5.23523 15.4828 6.55014 17.7174C7.04138 18.5558 7.84288 19.3795 8.62592 19.8596L8.85861 20L12.0425 19.9741L15.23 19.9446L15.3814 19.8596C15.9096 19.5531 16.6557 18.8698 17.0731 18.3157C17.701 17.4736 18.111 16.4911 18.2846 15.4274C18.3437 15.0469 18.3437 13.9204 18.2809 13.5621C18.0925 12.4578 17.6899 11.5122 17.0546 10.6738C16.9327 10.5149 16.8367 10.382 16.8367 10.3709C16.8367 10.3635 16.9032 10.249 16.9807 10.1197C17.1617 9.82425 17.3242 9.44382 17.4129 9.1114C17.5126 8.74204 17.5126 7.81865 17.4129 7.4493C17.0583 6.13808 15.9946 5.04479 14.4913 4.44274C14.0702 4.27284 13.35 4.09185 12.8846 4.03276C12.4524 3.98105 11.385 3.99213 10.9824 4.05492ZM13.2318 4.65697C15.2041 5.05218 16.6483 6.29321 16.9143 7.82235C16.9734 8.16585 16.9364 8.74943 16.8367 9.07446C16.737 9.39211 16.5523 9.76516 16.3344 10.0828C16.2457 10.2121 16.1719 10.3598 16.1719 10.4078C16.1719 10.4559 16.2494 10.5814 16.3602 10.707C17.2836 11.7597 17.7712 13.0783 17.7712 14.504C17.7675 16.1255 17.1617 17.5475 15.9946 18.6629C15.7951 18.855 15.5107 19.0951 15.3593 19.1985L15.0823 19.3906L12.0277 19.4016L8.9768 19.4164L8.74042 19.2613C7.88351 18.6888 7.11156 17.7432 6.6831 16.7386C6.14385 15.468 6.08844 13.9943 6.52798 12.672C6.76067 11.985 7.07093 11.4236 7.5437 10.8326C7.73577 10.5962 7.82441 10.4559 7.82441 10.3894C7.82441 10.334 7.72838 10.153 7.6028 9.96461C7.15957 9.30346 6.97859 8.56844 7.0857 7.87405C7.19651 7.17228 7.50677 6.59608 8.07927 6.02358C8.82537 5.28118 9.86695 4.78994 11.0895 4.60526C11.5955 4.52769 12.7147 4.55724 13.2318 4.65697Z" fill="#6C787C"/>
    <path d="M11.1486 5.30692C9.63427 5.56177 8.44864 6.42606 8.06082 7.55999C7.97217 7.81484 7.9574 7.91457 7.9574 8.28023C7.9574 8.64589 7.97217 8.74562 8.06082 9.00047C8.11622 9.16299 8.21964 9.3883 8.28982 9.5028C8.48188 9.82044 8.56683 9.83152 8.94727 9.59514C9.51608 9.23686 10.1698 8.97462 10.8495 8.83057C11.3075 8.73454 12.1865 8.6976 12.6851 8.7567C13.4645 8.84904 14.3103 9.13713 14.9862 9.54712C15.1783 9.66162 15.3741 9.75765 15.4221 9.75765C15.7028 9.75765 16.0611 8.9266 16.0611 8.28023C16.0611 6.84344 14.724 5.61348 12.8292 5.30692C12.4266 5.24043 11.5365 5.24043 11.1486 5.30692ZM12.9769 5.89789C13.6122 6.03824 14.1958 6.30418 14.6353 6.65507C15.2263 7.12415 15.544 7.77791 15.4923 8.4095C15.4738 8.66067 15.3814 9.00047 15.326 9.03741C15.3113 9.0448 15.1044 8.95615 14.868 8.83796C14.3768 8.59418 13.8191 8.39842 13.254 8.27284C12.9105 8.19897 12.7664 8.18789 11.9981 8.19158C11.241 8.19158 11.0821 8.20267 10.7534 8.27284C10.1846 8.39842 9.74138 8.55355 9.19474 8.81949C8.6444 9.08912 8.67395 9.09281 8.57422 8.76039C8.44495 8.32825 8.52621 7.75574 8.77737 7.3236C8.91033 7.0946 9.276 6.71416 9.54193 6.52579C10.048 6.16752 10.4912 6.005 11.4441 5.82771C11.6399 5.79077 12.7258 5.84248 12.9769 5.89789Z" fill="#6C787C"/>
    <path d="M12.3748 10.6626C12.2714 10.7956 12.2714 10.9212 12.3785 11.0283C12.4487 11.0985 12.5189 11.1169 12.7737 11.1354C13.2687 11.1724 13.7415 11.3201 14.1662 11.5713C14.4691 11.7559 14.9308 12.2029 15.1376 12.5242C15.4442 12.9859 15.6547 13.647 15.6547 14.1346C15.6547 14.3045 15.6695 14.3562 15.7471 14.4301C15.8652 14.552 16.0204 14.552 16.1349 14.4301C16.2161 14.3451 16.2198 14.323 16.1977 13.961C16.0942 12.1733 14.6057 10.6811 12.8255 10.5814L12.4561 10.5592L12.3748 10.6626Z" fill="#6C787C"/>
    </svg>
    `;
    let caffeineIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.04679 4.02933C7.77722 4.19506 6.52328 4.98932 5.62895 6.20261C4.62205 7.56912 4.06856 9.25459 4.00289 11.1558C3.91846 13.5887 4.75651 15.9496 6.22934 17.4255C7.9836 19.186 10.2945 19.4237 12.2489 18.0415C12.8117 17.6444 13.5528 16.8345 13.925 16.2091L14.0469 16.0027H14.8818H15.7167L15.7261 17.7445C15.7355 19.4706 15.7355 19.4894 15.8043 19.6176C16.0044 19.9897 16.4203 20.1085 16.7768 19.8927L16.9238 19.8021L18.4498 16.7563C20.1321 13.4042 20.0758 13.5324 19.9445 13.2322C19.8569 13.0414 19.7725 12.9445 19.613 12.8726C19.4973 12.8194 19.3879 12.8132 18.2778 12.8132H17.0645V11.0777C17.0645 9.57668 17.0582 9.32339 17.0145 9.22332C16.9113 8.97003 16.6674 8.81368 16.3828 8.81056C16.0076 8.81056 15.9012 8.92313 15.4979 9.72678C15.3259 10.0739 15.1695 10.3709 15.1539 10.3866C15.1382 10.4053 15.1257 10.3741 15.1257 10.3084C15.1257 10.1646 14.9944 9.42971 14.9068 9.09199C14.1908 6.28392 12.3052 4.29825 10.1069 4.02933C9.78477 3.98867 9.3595 3.9918 9.04679 4.02933ZM10.0287 4.56092C10.9981 4.67975 11.8611 5.13629 12.6429 5.93681C13.8186 7.14697 14.5629 9.02007 14.6473 10.9682L14.6661 11.4216L13.7342 13.2822L12.8055 15.1428L12.818 15.3492C12.8274 15.5118 12.8493 15.5837 12.9149 15.6869C13.0087 15.8276 13.1495 15.9308 13.2902 15.9621C13.3371 15.9715 13.384 15.9933 13.3934 16.009C13.4027 16.0215 13.3433 16.1309 13.262 16.2466C12.5053 17.3161 11.5484 18.0228 10.4852 18.2886C10.3351 18.3261 10.2069 18.348 10.1975 18.3386C10.1882 18.3292 10.2413 18.2167 10.3195 18.0916C10.751 17.3786 11.0231 16.6125 11.1419 15.7651C11.2107 15.2554 11.1888 14.2453 11.095 13.8107C11.0043 13.3948 10.8949 13.0696 10.7166 12.6943C10.5227 12.2909 10.3195 11.9782 9.79728 11.2872C9.14373 10.421 8.95611 10.0989 8.76223 9.52039C8.2494 7.97877 8.62777 5.76795 9.5909 4.67349C9.66282 4.59219 9.73161 4.52652 9.74412 4.52652C9.7535 4.52652 9.88484 4.54216 10.0287 4.56092ZM8.94673 4.62659C8.93422 4.64848 8.87168 4.74542 8.81226 4.83923C8.52458 5.29265 8.27442 5.9587 8.13995 6.62789C7.86165 8.00065 7.99298 9.27648 8.51207 10.3084C8.70595 10.6993 8.86542 10.9432 9.33135 11.5561C10.1413 12.6255 10.3945 13.104 10.5665 13.892C10.6478 14.261 10.676 15.1459 10.6228 15.5962C10.5227 16.4843 10.16 17.4193 9.62529 18.1823C9.44705 18.4356 9.50959 18.4168 9.01239 18.3449C7.82725 18.176 6.69527 17.3849 5.86348 16.1434C4.29058 13.795 4.09045 10.2896 5.37879 7.64417C6.15429 6.05564 7.29878 5.01121 8.66842 4.65161C8.93422 4.57968 8.978 4.57656 8.94673 4.62659ZM16.4954 9.37967C16.5235 9.40782 16.5329 9.87374 16.5329 11.284V13.154L16.6079 13.2416L16.683 13.3291L18.0464 13.3385L19.4129 13.3479L19.4473 13.4261C19.4817 13.5011 19.366 13.7419 18.0026 16.4749C16.4485 19.58 16.4641 19.555 16.3296 19.4425C16.289 19.4081 16.2827 19.1548 16.2827 17.5756C16.2827 15.6306 16.2796 15.5837 16.1326 15.5055C16.0889 15.4836 15.6386 15.4711 14.7661 15.4711C13.9281 15.4711 13.4434 15.4586 13.4027 15.4399C13.3683 15.4211 13.3433 15.3742 13.3433 15.3304C13.3433 15.2616 16.2046 9.48599 16.289 9.37967C16.3296 9.33277 16.4453 9.32964 16.4954 9.37967Z" fill="#6C787C"/>
    </svg>
    `;
    let detailsIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.8781 4.05312C10.825 4.09688 10.7812 4.2375 10.6719 4.70312C10.5969 5.02812 10.525 5.325 10.5188 5.3625C10.5062 5.4125 10.4594 5.4375 10.3219 5.46875C9.8625 5.56875 9.2 5.83437 8.70937 6.1125L8.40625 6.28438L8.2875 6.21562C8.225 6.175 7.98438 6.02812 7.75625 5.88437C7.25312 5.56875 7.22813 5.55625 7.10938 5.60938C7.05625 5.63125 6.69688 5.97188 6.30625 6.36562C5.6625 7.00937 5.59375 7.09062 5.59375 7.18437C5.59375 7.2625 5.675 7.42188 5.91875 7.80937C6.09375 8.09375 6.25 8.34688 6.2625 8.36875C6.275 8.39062 6.21875 8.525 6.12812 8.68437C5.85625 9.15625 5.67188 9.60312 5.5 10.1875C5.45312 10.35 5.39375 10.4937 5.37188 10.5062C5.34688 10.5188 5.05313 10.5938 4.71875 10.6687C4.2375 10.7812 4.09688 10.825 4.05625 10.8781C4.00625 10.9375 4 11.0406 4 12C4 12.9594 4.00625 13.0625 4.05625 13.1219C4.09688 13.175 4.2375 13.2188 4.71875 13.3312C5.05313 13.4062 5.35 13.4781 5.37813 13.4875C5.40938 13.4969 5.44063 13.55 5.45312 13.6188C5.52813 14.0187 5.83438 14.8 6.1125 15.2875C6.2125 15.4656 6.275 15.6094 6.2625 15.6344C6.25 15.6531 6.09375 15.9062 5.91562 16.1937C5.67813 16.5781 5.59375 16.7406 5.59375 16.8156C5.59375 16.9094 5.66875 16.9937 6.3375 17.6625C7.00625 18.3312 7.09063 18.4062 7.18438 18.4062C7.25938 18.4062 7.42188 18.3219 7.80625 18.0844C8.09375 17.9062 8.34688 17.75 8.36875 17.7375C8.39062 17.725 8.52187 17.7781 8.68438 17.8719C9.16875 18.15 9.98125 18.475 10.3844 18.5469C10.4656 18.5625 10.5062 18.5875 10.5156 18.6375C10.525 18.6719 10.5969 18.9688 10.6719 19.2969C10.7812 19.7625 10.825 19.9031 10.8781 19.9437C10.9375 19.9937 11.0406 20 12 20C12.9594 20 13.0625 19.9937 13.1219 19.9437C13.175 19.9031 13.2188 19.7594 13.3313 19.2812C13.4094 18.9469 13.4781 18.65 13.4875 18.6219C13.4969 18.5906 13.55 18.5594 13.6188 18.5469C14.0188 18.4719 14.8 18.1656 15.2875 17.8875C15.4625 17.7906 15.6094 17.725 15.6344 17.7375C15.6531 17.75 15.9062 17.9062 16.1906 18.0812C16.5375 18.2969 16.7406 18.4062 16.8 18.4062C16.8781 18.4062 17.0094 18.2875 17.65 17.6469C18.2844 17.0125 18.4062 16.875 18.4062 16.8C18.4062 16.7406 18.2969 16.5344 18.0813 16.1906C17.9062 15.9062 17.75 15.6531 17.7375 15.6312C17.725 15.6094 17.7812 15.475 17.8719 15.3156C18.15 14.8312 18.475 14.0187 18.5469 13.6156C18.5625 13.5344 18.5875 13.4938 18.6375 13.4812C18.6719 13.475 18.9688 13.4031 19.2969 13.3281C19.7688 13.2219 19.9 13.1781 19.9438 13.125C19.9938 13.0625 20 12.9656 20 12C20 11.0406 19.9938 10.9375 19.9438 10.8781C19.8906 10.8125 19.8063 10.7875 18.6375 10.5156C18.5875 10.5062 18.5625 10.4594 18.5312 10.3219C18.4313 9.8625 18.1656 9.2 17.8875 8.7125C17.7906 8.5375 17.725 8.39062 17.7375 8.36562C17.75 8.34688 17.9062 8.09375 18.0813 7.80937C18.325 7.42188 18.4062 7.2625 18.4062 7.18437C18.4062 7.09062 18.3375 7.00937 17.6969 6.36562C17.3031 5.97188 16.9438 5.63125 16.8906 5.60938C16.8375 5.58437 16.7719 5.57812 16.7344 5.59375C16.7 5.60625 16.4563 5.75313 16.1938 5.91875C15.9313 6.08125 15.6906 6.23125 15.6562 6.25C15.6062 6.275 15.5406 6.25 15.2875 6.10938C14.8 5.8375 14.0063 5.51875 13.65 5.45312C13.5844 5.44063 13.5219 5.41562 13.5063 5.39375C13.4906 5.375 13.4156 5.08437 13.3406 4.75C13.2344 4.28438 13.1875 4.125 13.1344 4.06875C13.0656 4 13.0625 4 12.0063 4C11.0406 4 10.9375 4.00625 10.8781 4.05312ZM12.9625 5.0625C13.0563 5.48125 13.1188 5.69375 13.1625 5.74062C13.2031 5.78438 13.3094 5.825 13.4625 5.85938C14.0094 5.98125 14.7031 6.26562 15.2156 6.575C15.3906 6.67812 15.5469 6.75 15.5969 6.75C15.6562 6.75 15.8656 6.6375 16.2125 6.42188C16.5031 6.24062 16.7531 6.09375 16.7688 6.09375C16.7844 6.09375 17.05 6.34688 17.3562 6.65312C17.7281 7.025 17.9094 7.22812 17.8969 7.25937C17.8875 7.28438 17.7375 7.53438 17.5625 7.8125C17.375 8.1125 17.2438 8.35312 17.2438 8.40312C17.2438 8.45 17.3219 8.6125 17.425 8.78125C17.7344 9.2875 18.0406 10.0562 18.1531 10.6C18.175 10.7 18.2188 10.8 18.2531 10.8313C18.2969 10.8687 18.5375 10.9406 18.9313 11.0344L19.5469 11.1781V12V12.8219L18.9313 12.9656C18.5844 13.0469 18.2875 13.1312 18.2531 13.1625C18.2188 13.1906 18.1781 13.2906 18.1562 13.3969C18.05 13.9219 17.6687 14.8438 17.3531 15.3344C17.2906 15.4313 17.2406 15.55 17.2406 15.5938C17.2406 15.6375 17.3719 15.8844 17.5594 16.1844C17.7344 16.4656 17.8875 16.7156 17.8969 16.7406C17.9094 16.7719 17.7281 16.975 17.3562 17.3469C17.05 17.6531 16.7844 17.9062 16.7688 17.9062C16.7531 17.9062 16.5 17.7562 16.2063 17.5719C15.8938 17.3781 15.6375 17.2406 15.5938 17.2406C15.55 17.2406 15.4313 17.2906 15.3344 17.3531C14.8438 17.6688 13.9219 18.05 13.3969 18.1562C13.2906 18.1781 13.1906 18.2188 13.1625 18.2531C13.1313 18.2875 13.0469 18.5844 12.9656 18.9312L12.8219 19.5469H12H11.1781L11.0344 18.9312C10.9563 18.5906 10.8688 18.2875 10.8406 18.2563C10.8094 18.2188 10.675 18.1687 10.4969 18.125C9.90625 17.9844 9.2375 17.7031 8.69688 17.3687C8.57812 17.3 8.45 17.2406 8.40625 17.2406C8.3625 17.2406 8.1125 17.375 7.81562 17.5594C7.53437 17.7344 7.28437 17.8875 7.25938 17.8969C7.22813 17.9094 7.025 17.7281 6.65313 17.3563C6.34687 17.05 6.09375 16.7844 6.09375 16.7687C6.09375 16.7531 6.24375 16.5 6.425 16.2094C6.61875 15.8969 6.75625 15.6469 6.75625 15.5969C6.75938 15.55 6.70938 15.4313 6.64375 15.3312C6.33125 14.8438 5.95 13.9219 5.84375 13.3969C5.82187 13.2937 5.78125 13.1906 5.74688 13.1625C5.7125 13.1312 5.4125 13.0469 5.06875 12.9656L4.45312 12.8219V12V11.1781L5.06875 11.0344C5.41562 10.9531 5.7125 10.8687 5.74688 10.8375C5.78125 10.8094 5.82187 10.7094 5.84375 10.6031C5.95312 10.075 6.27813 9.26562 6.59687 8.75C6.68438 8.60312 6.75938 8.45 6.75938 8.40625C6.75938 8.35938 6.62188 8.10625 6.42813 7.79375C6.24375 7.5 6.09375 7.24687 6.09375 7.23125C6.09375 7.17188 7.2125 6.08437 7.25625 6.10312C7.28125 6.1125 7.53125 6.25937 7.80938 6.43437C8.15625 6.65 8.34688 6.75 8.40938 6.75C8.4625 6.75 8.57812 6.70312 8.68125 6.63437C9.15625 6.32812 10.0781 5.95 10.6031 5.84375C10.7031 5.825 10.8094 5.78125 10.8375 5.74687C10.8719 5.7125 10.9437 5.46875 11.0281 5.10312C11.1 4.77812 11.1656 4.49687 11.1719 4.475C11.1844 4.44375 11.3656 4.4375 12.0031 4.44375L12.8219 4.45312L12.9625 5.0625Z" fill="#6C787C"/>
    <path d="M11.3656 7.79678C9.56563 8.09053 8.18125 9.4249 7.82188 11.2124C7.74687 11.5874 7.74687 12.4124 7.82188 12.7874C8.08437 14.0937 8.92813 15.2093 10.1031 15.803C10.4406 15.9718 11.0063 16.1468 11.4062 16.2062C11.8219 16.2655 12.3875 16.253 12.8063 16.1718C14.5 15.8437 15.8344 14.503 16.1781 12.7812C16.2563 12.3999 16.2531 11.5812 16.175 11.203C15.8188 9.4874 14.5594 8.20928 12.8594 7.84053C12.4781 7.75615 11.7375 7.73428 11.3656 7.79678ZM12.5625 8.23115C14.1531 8.47178 15.3938 9.65303 15.7375 11.2562C15.8094 11.5812 15.8156 12.3499 15.7531 12.6718C15.3031 14.9687 13.0219 16.3312 10.8125 15.6218C10.4844 15.5155 10.0031 15.2655 9.7125 15.0468C8.03125 13.7843 7.69375 11.3937 8.95625 9.70928C9.79063 8.59678 11.1875 8.0249 12.5625 8.23115Z" fill="#6C787C"/>
    </svg>
    `;
    let ingredIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.6091 4.05782C17.288 4.15835 17.0351 4.31726 16.8081 4.55723C16.286 5.11177 16.166 5.87385 16.4968 6.57757C16.5454 6.68458 16.5843 6.77863 16.5843 6.7916C16.5876 6.80457 15.4817 7.59584 14.1294 8.54926L11.6681 10.2842L11.4281 10.0799C10.9644 9.68428 10.5331 9.51241 9.9396 9.48646C9.49208 9.46701 9.17103 9.52862 8.82728 9.69725L8.63595 9.79454L8.45758 9.54484C8.3603 9.40863 7.8771 8.73411 7.38094 8.04337L6.48265 6.78836L6.62534 6.58081C6.8264 6.28895 6.89126 6.0814 6.88801 5.7636C6.87504 4.84261 5.98 4.20375 5.08819 4.48264C4.69904 4.60263 4.40394 4.86207 4.22558 5.24797C4.14451 5.41985 4.13478 5.47498 4.13478 5.77981C4.13478 6.09437 4.14126 6.13653 4.23855 6.34083C4.54987 6.99266 5.27953 7.32344 5.91838 7.09968L6.0481 7.05428L7.12799 8.5752L8.20788 10.0961L8.11059 10.1934C7.80252 10.4983 7.59821 10.8485 7.47498 11.2766C7.27392 11.9738 7.41985 12.804 7.84792 13.3715C7.91602 13.4655 7.96466 13.5563 7.95493 13.5758C7.91277 13.6471 6.67398 15.4761 6.67074 15.4761C6.6675 15.4761 6.58318 15.4437 6.48589 15.408C6.26537 15.3205 5.76921 15.288 5.50977 15.3432C4.85146 15.4794 4.25801 16.0761 4.12181 16.7344C3.92399 17.6813 4.51096 18.6218 5.4514 18.865C5.75624 18.9461 6.23294 18.9169 6.53129 18.8034C7.70847 18.3526 8.08141 16.8576 7.24473 15.9366L7.0761 15.7518L7.67928 14.86C8.01006 14.3703 8.2922 13.9552 8.30841 13.9357C8.32463 13.9163 8.36678 13.926 8.42516 13.9617C9.12563 14.4125 9.88447 14.5097 10.6109 14.2438C10.9838 14.1076 11.2335 13.9422 11.5481 13.6244L11.8302 13.3423L12.6345 13.5271L13.4387 13.712L13.4776 13.9714C13.5392 14.4125 13.7111 14.7108 14.0419 14.9605C14.3986 15.2297 14.9564 15.2913 15.3909 15.1129L15.5888 15.0319L16.3346 15.8069L17.0837 16.5852L16.9573 16.7668C16.7919 17.0035 16.7205 17.2403 16.7205 17.5743C16.7173 17.8337 16.7141 17.8435 16.6362 17.8597C16.4968 17.8889 15.1477 18.1029 15.1023 18.1029C15.0796 18.1029 14.9985 18.0088 14.924 17.8953C14.4408 17.156 13.416 17.0522 12.7901 17.6781C12.1059 18.3623 12.3231 19.4909 13.2182 19.9092C13.3901 19.9903 13.4452 20 13.7662 20C14.0873 20 14.1424 19.9903 14.3143 19.9092C14.564 19.7925 14.7618 19.6271 14.9045 19.4195C15.031 19.2314 15.1445 18.9007 15.1445 18.719V18.5958L15.3715 18.5569C15.4947 18.5374 15.9098 18.4629 16.286 18.3948L16.9767 18.2715L17.1324 18.4466C17.3205 18.6574 17.6675 18.839 17.9528 18.878C18.5431 18.959 19.1138 18.6574 19.3797 18.1224C19.7981 17.2727 19.263 16.2836 18.3128 16.1474C18.102 16.1182 18.0339 16.1215 17.8004 16.1798L17.5313 16.2447L16.9605 15.6577C16.646 15.3334 16.3087 14.9832 16.2082 14.8762L16.0233 14.6816L16.1368 14.4514C16.286 14.1563 16.3379 13.8612 16.286 13.5952C16.1757 12.9953 15.7282 12.5543 15.1315 12.4537C14.6256 12.3694 14.0646 12.6126 13.776 13.0375C13.7208 13.1218 13.6722 13.1964 13.6657 13.1996C13.6592 13.2126 12.1578 12.8818 12.1351 12.8656C12.1318 12.8623 12.1578 12.7424 12.1967 12.6029C12.2518 12.4051 12.268 12.2592 12.2713 11.9576C12.2713 11.5392 12.2129 11.2603 12.0475 10.8842C12.0021 10.7804 11.9762 10.6863 11.9891 10.6766C12.0053 10.6636 12.4302 10.3621 12.9393 10.0053C13.4484 9.64861 14.5608 8.86707 15.4104 8.26713L16.9605 7.17751L17.1454 7.30074C17.4275 7.48558 17.6772 7.5699 18.0145 7.58611C18.9127 7.63476 19.6716 7.07373 19.8791 6.20463C19.9343 5.9679 19.9278 5.52686 19.8629 5.29986C19.6846 4.69019 19.1916 4.207 18.582 4.04485C18.3323 3.97999 17.8329 3.98648 17.6091 4.05782ZM18.5982 4.54426C19.2111 4.75829 19.5711 5.4393 19.4122 6.07167C19.3051 6.49001 19.01 6.83052 18.6241 6.98293C18.3582 7.08671 17.9301 7.08671 17.6642 6.98293C17.2718 6.83052 16.98 6.48677 16.873 6.0587C16.8276 5.87385 16.8243 5.79603 16.8535 5.59821C16.9735 4.75505 17.7939 4.26213 18.5982 4.54426ZM5.84379 4.96259C5.98973 5.02421 6.20052 5.235 6.27834 5.40687C6.48589 5.85115 6.26862 6.41866 5.81461 6.60675C5.633 6.68458 5.32493 6.67486 5.12387 6.5873C4.83525 6.46407 4.605 6.11383 4.605 5.79927C4.605 5.51065 4.8093 5.1669 5.07522 5.00151C5.2698 4.88152 5.60058 4.86531 5.84379 4.96259ZM10.2217 10.0313C10.919 10.1772 11.5384 10.7771 11.72 11.4776C11.8821 12.1035 11.681 12.8137 11.2076 13.2872C10.8217 13.6731 10.3806 13.8547 9.84231 13.8547C9.30399 13.8547 8.86295 13.6731 8.47704 13.2872C7.71171 12.5251 7.72144 11.3479 8.4965 10.5728C8.76242 10.3037 9.07698 10.1253 9.41749 10.041C9.62828 9.98912 10.0012 9.98587 10.2217 10.0313ZM15.2418 13.0148C15.8125 13.2709 15.9552 14.0233 15.5174 14.4481C15.3455 14.6168 15.0829 14.7076 14.8364 14.6881C14.5964 14.6719 14.4148 14.5843 14.2559 14.406C14.0905 14.2211 14.0322 14.0719 14.0289 13.8222C14.0224 13.4461 14.2462 13.1218 14.6029 12.9888C14.7715 12.9272 15.0764 12.9402 15.2418 13.0148ZM6.12593 15.8004C6.68047 15.8912 7.11502 16.329 7.20582 16.89C7.29986 17.4543 6.99503 18.0218 6.45995 18.2748C6.26213 18.3688 6.21673 18.3785 5.91838 18.3785C5.62003 18.3785 5.57463 18.3688 5.37681 18.2748C4.56608 17.8921 4.3553 16.8641 4.95523 16.2188C5.20494 15.9496 5.48059 15.8166 5.88595 15.7712C5.90541 15.7712 6.01243 15.7842 6.12593 15.8004ZM18.4977 16.7441C18.9517 16.9549 19.1495 17.4965 18.929 17.9278C18.8349 18.1126 18.663 18.2813 18.4879 18.3558C18.3355 18.4207 17.9528 18.4207 17.8004 18.3558C17.4859 18.2196 17.2751 17.8889 17.2751 17.5354C17.2718 17.2014 17.4567 16.916 17.7777 16.7506C17.9658 16.6533 18.2966 16.6501 18.4977 16.7441ZM14.1262 17.8759C14.7132 18.1256 14.8137 18.9688 14.3078 19.3579C13.7176 19.8087 12.8971 19.4098 12.8971 18.6704C12.8939 18.0348 13.5328 17.6229 14.1262 17.8759Z" fill="#6C787C"/>
    <path d="M9.42084 10.5405C9.04466 10.6702 8.71064 10.9653 8.5485 11.3026C8.43824 11.5393 8.37987 11.8798 8.43175 12.003C8.48364 12.1295 8.62633 12.1911 8.7528 12.136C8.85982 12.0938 8.90522 11.9998 8.93116 11.7695C8.9571 11.562 9.04466 11.3966 9.22627 11.2312C9.40463 11.0658 9.5311 11.0107 9.78081 10.9815C10.0046 10.9556 10.0856 10.8842 10.0856 10.7253C10.0856 10.5502 9.99484 10.4821 9.77108 10.4821C9.6673 10.4853 9.5084 10.508 9.42084 10.5405Z" fill="#6C787C"/>
    </svg>
    `;
    let html;
    preSeries.forEach((el) => {
      if (window.location.pathname.includes(el)) {
        html = `
     <div 545 id="compareChart" class="compare-chart-container">
     <div class="compare-title"><h1>COMPARE PRE-WORKOUT</h1></div>
     <div class="compare-chart-wrap">
     <div class="cc-inner">
     <div class="compare-card" 45>
     <img class="compare-img" src="https://cdn.shopify.com/s/files/1/0866/7664/files/bulk-pre.png?v=1692039475"/>
     <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.7</p></div>
     <p class="cc-product-title">Bulk Pre-Workout</p>
     <div class="cc-details">
     <ul id="pre-list">
     <li class="details">${detailsIcon}<span class="cc-reg">Improve strength, delay fatigue, trigger growth</span></li>
     <li>${caffeineIcon}<span class="cc-bold">200mg</span><span class="cc-reg">caffeine</span></li>
     <li id="ingred-list">
     ${ingredIcon}
     <div>
     <p><span class="cc-bold">8g</span><span class="cc-reg">Citrulline Malate,</span></p>
     <p><span class="cc-bold">4g</span><span class="cc-reg">Beta-Alinine,</span></p>
     <p><span class="cc-bold">2.5g</span><span class="cc-reg">Betaine Anhydrous</span></p>
     </div>
     </li>
     <li id="last">${weightIcon}<div><div class="scoops"><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt.</span><span class="cc-bold">615 - 707g)</span></div></div></li>
     </ul>
     </div>
     <a href="/collections/preseries/products/preseries-bulk-preworkout"><span>Shop from 12 flavors</span>${shopSvg}</a>
     </div>
     <div class="compare-card">
     <img class="compare-img" src="https://cdn.shopify.com/s/files/1/0866/7664/files/lean-pre.png?v=1692039513"/>
     <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.6</p></div>
     <p class="cc-product-title">lean pre-workout</p>
     <div class="cc-details">
     <ul id="pre-list">
          <li class="details">${detailsIcon}<span class="cc-reg">Fat burning and thyroid support complex</span></li>
          <li>${caffeineIcon}<span class="cc-bold">180mg</span><span class="cc-reg">caffeine</span></li>
          <li id="ingred-list">
          ${ingredIcon}
          <div>
          <p><span class="cc-bold">6g</span><span class="cc-reg">Citrulline Malate,</span></p>
          <p><span class="cc-bold">2g</span><span class="cc-reg">Beta-Alinine,</span></p>
          <p><span class="cc-bold">1.5g</span><span class="cc-reg">Betaine Anhydrous,</span></p>
          <p><span class="cc-bold">1g</span><span class="cc-reg">Acetyl L-Carnitine</span></p>
          </div>
          </li>
          <li id="last">${weightIcon}<div><div class="scoops"><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg"> (Net Wt.</span><span class="cc-bold">492 - 513g)</span></div></div></li>
     </ul>
     </div>
     <a href="/collections/preseries/products/preseries-lean-pre-workout"><span>Shop from 10 flavors</span>${shopSvg}</a>
     </div>
     
      <div class="compare-card">
     <img class="compare-img" src="https://cdn.shopify.com/s/files/1/0866/7664/files/bulk-black.png?v=1692039475"/>
     <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.5</p></div>
     <p class="cc-product-title">bulk black pre-workout</p>
     <div class="cc-details">
     <ul id="pre-list">
     <li class="details">${detailsIcon}<span class="cc-reg">Additional nootropics, jitter-free formula</span></li>
     <li>${caffeineIcon}<span class="cc-bold">275mg</span><span class="cc-reg">caffeine</span></li>
     <li id="ingred-list">
     ${ingredIcon}
     <div>
          <p><span class="cc-bold">8g</span><span class="cc-reg">Citrulline Malate,</span></p>
          <p><span class="cc-bold">4g</span><span class="cc-reg">Beta-Alinine,</span></p>
          <p><span class="cc-bold">2.5g</span><span class="cc-reg">Betaine Anhydrous,</span></p>
          <p><span class="cc-bold">1300mg</span><span class="cc-reg">Taurine,</span></p>
          <p><span class="cc-bold">1g</span><span class="cc-reg">L-Tyrosine</span></p>
          </div>
          </li>
     <li id="last">${weightIcon}<div><div class="scoops"><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg"> (Net Wt.</span><span class="cc-bold">630 - 705g)</span></div></div></li>
     </ul>
     </div>
     <a href="/collections/preseries/products/preseries-bulk-black"><span>Shop from 5 flavors</span>${shopSvg}</a>
     </div>
     
     <div class="compare-card">
     <img class="compare-img" src="https://cdn.shopify.com/s/files/1/0866/7664/files/stim-free.png?v=1692039549"/>
     <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.6</p></div>
     <p class="cc-product-title">stim-free pre-workout</p>
     <div class="cc-details">
     <ul id="pre-list">
          <li class="details">${detailsIcon}<span class="cc-reg">Stimulant and caffeine free formula</span></li>
          <li>${caffeineIcon}<span class="cc-bold">0mg</span><span class="cc-reg">caffeine</span></li>
          <li id="ingred-list">
          ${ingredIcon}
          <div>
          <p><span class="cc-bold">6g</span><span class="cc-reg">Citrulline Malate,</span></p>
          <p><span class="cc-bold">4g</span><span class="cc-reg">Beta-Alinine,</span></p>
          <p><span class="cc-bold">2.5g</span><span class="cc-reg">Betaine Anhydrous,</span></p>
          <p><span class="cc-bold">1300mg</span><span class="cc-reg">Taurine</span></p>
          </div>
          </li>
          <li id="last">${weightIcon}<div><div class="scoops"><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg"> (Net Wt.</span><span class="cc-bold">609 - 702g)</span></div></div></li>
     </ul>
     </div>
     <a href="/collections/preseries/products/preseries-stim-free-preworkout"><span>Shop from 8 flavors</span>${shopSvg}</a>
     </div>
     <div class="compare-card">
     <img class="compare-img" src="https://cdn.shopify.com/s/files/1/0866/7664/files/pump-pre.png?v=1692039549"/>
     <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.3</p></div>
     <p class="cc-product-title">pump pre-workout</p>
     <div class="cc-details">
     <ul id="pre-list">
     <li class="details">${detailsIcon}<span class="cc-reg">Stimulant and caffeine free with vasodilating, cell-volumizing nutrients</span></li>
     <li>${caffeineIcon}<span class="cc-bold">0mg</span><span class="cc-reg">caffeine</span></li>
     <li id="ingred-list">
     ${ingredIcon}
     <div>
     <p><span class="cc-bold">8g</span><span class="cc-reg">Citrulline Malate,</span></p>
     <p><span id="Nitrate" class="cc-reg"><strong>2.5g</strong>NO3-T®Arginine Nitrate,</span></p>
     <p><span class="cc-bold">2.5g</span><span class="cc-reg">Betaine Anhydrous</span></p>
     </div>
     </li>
     <li id="last">${weightIcon}<div><div class="scoops"><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg"> (Net Wt.</span><span class="cc-bold">597g)</span></div></div></li>
     </ul>
     </div>
     <a href="/collections/preseries/products/preseries-pump"><span>Shop from 2 flavors</span>${shopSvg}</a>
     </div>

   
     </div>
     </div>
     </div>
      `;
      }
    });
    proteinSeries.forEach((el) => {
      if (window.location.pathname.includes(el)) {
        html = `
        <div id="compareChart" class="compare-chart-container">
        <div class="compare-title"><h1>COMPARE PROTEIN</h1></div>
        <div class="compare-chart-wrap">
        <div class="cc-inner">
        <div class="compare-card-p">
        <div class="bestsell-tag"><span>Bestseller</span></div>
        <img class="compare-img" src="https://cdn-3.convertexperiments.com/uf/10042583/10043452/img.png"/>
        <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.7</p></div>
        <p class="cc-product-title">100% Grass-Fed Whey Protein Isolate</p>
        <div class="cc-details">
        <ul>
        <li class="details-p">${detailsIcon}<span class="cc-reg">Best for most people and everyday use.</span></li>
   <li id="protein-li">${proteinIcon}<span class="cc-bold">28g</span><span class="cc-reg">protein per scoop</span></li>
   <li>${calorieIcon}<span class="cc-bold">120 - 150</span><span class="cc-reg">calories per scoop</span></li>
   <li>${carbIcon}<span class="cc-bold">0 - 3g</span><span class="cc-reg">carbs per scoop</span></li>
   <li id="last-p">${weightIcon}<div><div><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt. </span><span class="cc-bold">989g)</span></div></div></li>
        </ul>
        </div>
        <a class="protein-link" href="/collections/proteinseries/products/proteinseries-100-grass-fed-whey-protein-isolate"><span>Shop from 11 flavors</span>${shopSvg}</a>
        </div>
        <div class="compare-card-p">
        <div class="bestsell-tag"><span>Bestseller</span></div>
        <img class="compare-img" src="https://cdn-3.convertexperiments.com/uf/10042583/10043452/img-1.png"/>
        <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.6</p></div>
        <p class="cc-product-title">Mass Gainer Protein Powder</p>
        <div class="cc-details">
        <ul>
        <li class="details-p">${detailsIcon}<span class="cc-reg">Best for bulking.</span></li>
        <li id="protein-li">${proteinIcon}<span class="cc-bold">26 -27g</span><span class="cc-reg">protein per scoop</span></li>
        <li>${calorieIcon}<span class="cc-bold">365 - 375</span><span class="cc-reg">calories per scoop</span></li>
        <li>${carbIcon}<span class="cc-bold">53 - 55g</span><span class="cc-reg">carbs per scoop</span></li>
        <li id="last-p">${weightIcon}<div><div><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt. </span><span class="cc-bold">2910g)</span></div></div></li>
        </ul>
        </div>
        <a class="protein-link" href="/collections/proteinseries/products/proteinseries-mass-gainer"><span>Shop from 2 flavors</span>${shopSvg}</a>
        </div>
        <div class="compare-card-p">
        <div class="bestsell-tag"><span>Bestseller</span></div>
        <img class="compare-img" src="https://cdn-3.convertexperiments.com/uf/10042583/10043452/img-2.png"/>
        <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.2</p></div>
        <p class="cc-product-title">Organic Vegan Rice & Pea Protein</p>
        <div class="cc-details">
        <ul>
        <li class="details-p">${detailsIcon}<span class="cc-reg">Whey-free protein blend.</span></li>
        <li id="protein-li">${proteinIcon}<span class="cc-bold">24g</span><span class="cc-reg">protein per scoop</span></li>
        <li>${calorieIcon}<span class="cc-bold">130 - 150</span><span class="cc-reg">calories per scoop</span></li>
        <li>${carbIcon}<span class="cc-bold">3 - 7g</span><span class="cc-reg">carbs per scoop</span></li>
        <li id="last-p">${weightIcon}<div><div><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt. </span><span class="cc-bold">962g)</span></div></div></li>
        </ul>
        </div>
        <a class="protein-link" href="/collections/proteinseries/products/protein-series-organic-vegan"><span>Shop from 2 flavors</span>${shopSvg}</a>
        </div>
        <div class="compare-card-p">
        <div class="bestsell-tag"><span>Bestseller</span></div>
        <img class="compare-img" src="https://cdn-3.convertexperiments.com/uf/10042583/10043452/img-3.png"/>
        <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.5</p></div>
        <p class="cc-product-title">100% Grass-Fed Casein Protein</p>
        <div class="cc-details">
        <ul>
        <li class="details-p">${detailsIcon}<span class="cc-reg">Slow-absorption nighttime protein.</span></li>
        <li id="protein-li">${proteinIcon}<div><span class="cc-reg ch-ps"><strong>25g </strong>slow-absorption protein per scoop</span></div></li>
        <li>${calorieIcon}<span class="cc-bold">120</span><span class="cc-reg">calories per scoop</span></li>
        <li>${carbIcon}<span class="cc-bold">4g</span><span class="cc-reg">carbs per scoop</span></li>
        <li id="last-p">${weightIcon}<div><div><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt. </span><span class="cc-bold">1050g)</span></div></div></li>
        </ul>
        </div>
        <a class="protein-link" href="/collections/proteinseries/products/proteinseries-100-grass-fed-casein-protein"><span>Shop 1 flavor</span>${shopSvg}</a>
        </div>
        <div class="compare-card-p">
        <div class="bestsell-tag"><span>Bestseller</span></div>
        <img class="compare-img" src="https://cdn-3.convertexperiments.com/uf/10042583/10043452/img-4.png"/>
        <div class="compare-review"><div class="stars">${reviewStars}</div><p>4.6</p></div>
        <p class="cc-product-title">Collagen Hydrolysate Powder</p>
        <div class="cc-details">
        <ul>
        <li class="details-p">${detailsIcon}<span class="cc-reg">Great for skin health, anti-aging, and extra protein.</span></li>
        <li id="protein-li">${proteinIcon}<div><span class="ch-ps"><strong>10g </strong>protein,<br><strong>11g</strong> collagen hydrolysate per scoop</span></div></li>
        <li>${calorieIcon}<span class="cc-bold">45</span><span class="cc-reg">calories per scoop</span></li>
        <li>${carbIcon}<span class="cc-bold">2g</span><span class="cc-reg">carb per scoop</span></li>
        <li id="last-p">${weightIcon}<div><div><span class="cc-bold">30</span><span class="cc-reg">Scoops</span></div><div class="net-wt-wrap"><span class="cc-reg">(Net Wt. </span><span class="cc-bold">1050g)</span></div></div></li>
        </ul>
        </div>
        <a class="protein-link" href="/collections/proteinseries/products/proteinseries-collagen-hydrolysate"><span>Shop 1 flavor</span>${shopSvg}</a>
        </div>
        </div>
        </div>
        </div>
         `;
      }
    });
    if(typeof(html) !== 'undefined' && html !== 'null')
    {
      document.querySelector(".xt-icon-text").parentNode.insertAdjacentHTML("beforebegin", html);
    }
    else
    {     
    }
  
  },
};

(function SB017DV1PollFor() 
{
  if(document.querySelector(".xt-icon-text") && !document.querySelector(".compare-chart-container")) 
  {
    console.log("SB017DV1 - Variation - 1.7");
    SB017DV1.init();
  } 
  else 
  {
    setTimeout(SB017DV1PollFor, 25);
  }
})();

window.getSwiperSettings = function (swiperBreakpoints, viewportWidth) {
  const breakpoints = Object.keys(swiperBreakpoints)
    .map(Number)
    .sort((a, b) => a - b);

  if (viewportWidth < breakpoints[0]) {
    return swiperBreakpoints[breakpoints[0]];
  }
  if (viewportWidth > breakpoints[breakpoints.length - 1]) {
    return swiperBreakpoints[breakpoints[breakpoints.length - 1]];
  }
  for (let i = 0; i < breakpoints.length; i++) {
    if (viewportWidth >= breakpoints[i] && viewportWidth < breakpoints[i + 1]) {
      return swiperBreakpoints[breakpoints[i]];
    }
  }
};

window.updateFraction = function (swiperInstance, elem) {
  // console.log('swiperInstance',swiperInstance);
  const currentIndex = swiperInstance.realIndex + 1; // Real index starts at 0
  const totalSlides = swiperInstance.pagination.bullets.length; // Total slides

  const adjustedTotalSlides = totalSlides
  if(swiperInstance){
    swiperInstance.el.querySelector(elem).innerHTML = `<strong>${currentIndex.toString().padStart(2, '0')}</strong>/${adjustedTotalSlides.toString().padStart(2, '0')}`;
  }
}

window.fetchAndProcessCartData = function () {
  fetch(window.location.href, { method: "GET", credentials: "same-origin" })
    .then(response => {
      if (!response.ok) throw new Error("Failed to fetch the page");
      return response.text();
    })
    .then(html => {
      let parser = new DOMParser();
      let doc = parser.parseFromString(html, "text/html");
      let dataElement = doc.querySelector("[data-cart-json-ld]");
      
      if (!dataElement) throw new Error("Element [data-cart-json-ld] not found");
  
      let cartData = dataElement.innerHTML;
      processCartData(cartData);
    })
    .catch(error => {
      console.error("Error fetching or processing cart data:", error);
    });
};

function processCartData(cartData) {
  let productAvailableItems = [];
  if (!cartData.includes("@@@")) return;
  let items = cartData.split("@@@");
  items.forEach(item => {
    let parts = item.split("###");
    if (parts.length === 3) {
      let index = parseInt(parts[0], 10);
      let value = parseInt(parts[1], 10);
      let inventory_policy = parts[2];
      if (!isNaN(index) && !isNaN(value)) {
        productAvailableItems[index] = value
        document.querySelectorAll(`.cart--line-item[data-line-variant-id='${ index }']`).forEach(el => {
          // console.log(inventory_policy);
          if(value < window.stock_threshold && inventory_policy == "deny"){
            el.querySelector(".low--stock-text").classList.remove("hidden");
          }
        })        
      }
    }
  });
}

/***** Product Cards *****/
window.swiperBreakpoints = {
  400: { slidesPerView: 1.4, spaceBetween: 24 },
  520: { slidesPerView: 1.9, spaceBetween: 24 },
  640: { slidesPerView: 2.2, spaceBetween: 24 },
  1024: { slidesPerView: 3 },
  1280: { slidesPerView: 4 }
};

document.addEventListener("DOMContentLoaded", () => {
  let swiperInstances = [];
  
  document.querySelectorAll('.collection-swiper-container').forEach(swiperContainer => {
  // Find the correct child elements within THIS container
  const paginationEl = swiperContainer.querySelector('.featured-collections-pagination');
  const fractionSelector = '.featured-collections-fraction';

  if (!paginationEl) {
    console.warn('[Swiper] Pagination element not found for a collection-swiper-container:', swiperContainer);
    // skip initializing this instance!
    return;
  }

  try {
    const collectionSwiper = new Swiper(swiperContainer, {
      slidesPerView: 1.175,
      spaceBetween: 24,
      pagination: {
        el: paginationEl, // DOM element! Not a string selector!
        clickable: true
      },
      mousewheel: {
        invert: false,
        sensitivity: 1,
        forceToAxis: true,
      },
      breakpoints: window.swiperBreakpoints,
      on: {
        init: function () {
          // Find the proper fraction element scoped to this container
          const fractionEl = swiperContainer.querySelector(fractionSelector);
          if (window.updateFraction && typeof window.updateFraction === 'function') {
            window.updateFraction(this, fractionEl);
          }
        },
        slideChange: function () {
          const fractionEl = swiperContainer.querySelector(fractionSelector);
          if (window.updateFraction && typeof window.updateFraction === 'function') {
            window.updateFraction(this, fractionEl);
          }
        }
      }
    });

    (window.swiperInstances = window.swiperInstances || []).push(collectionSwiper);
  } catch (error) {
    console.error('Failed to initialize a Swiper instance', error, swiperContainer);
  }
});

  // Handle tab switching logic
  const tabs = document.querySelectorAll(".tab-button");
  const panels = document.querySelectorAll(".tab-panel");
  const collectionLinks = document.querySelectorAll(".tab-collection-link");

  tabs.forEach(tab => {
    tab.addEventListener("click", event => {
      event.preventDefault();
      tabs.forEach(t => t.classList.remove("active"));
      panels.forEach(p => p.classList.remove("active"));
      collectionLinks.forEach(c => c.classList.remove("active"));
      // panels.forEach(el => {
      //   el.querySelector(".featured-collections-fraction").innerHTML = "";
      // })

      tab.classList.add("active");
      const panelId = tab.dataset.tab;
      const activePanel = document.getElementById(panelId);
      activePanel.classList.add("active");
      const tabLink = document.querySelector(`.tab-collection-link[data-id="${panelId}"]`);
      if (tabLink) {
        tabLink.classList.add("active");
      }

      // setTimeout(function(){
      //   // Update fraction for the active swiper
      //   const activeSwiper = swiperInstances.find(swiper =>
      //     swiper.el.closest(`#${panelId}`)
      //   );
      //   if (activeSwiper) {
      //     window.updateFraction(activeSwiper, '.featured-collections-fraction');
      //   }
      // }, 500)
    });
  });

  // Handle window resize to update fraction
  window.addEventListener("resize", () => {
    const activeTab = document.querySelector(".tab-button.active");
    if (activeTab) {
      const panelId = activeTab.dataset.tab;
      const activeSwiper = swiperInstances.find(swiper =>
        swiper.el.closest(`#${panelId}`)
      );
      if (activeSwiper) {
        window.updateFraction(activeSwiper, '.featured-collections-fraction');
      }
    }
  });

  window.MatchHeightOfElementsProvided();
  
  // const openBtn = document.querySelector('.mobile-facets__open-wrapper');
  // const closeBtn = document.querySelector('.mobile-facets__close');
  // const facetForm = document.querySelector('.facet-filters-form');

  // // Open filter drawer
  // if (openBtn) {
  //   openBtn.addEventListener('click', function (e) {
  //     e.stopPropagation();
  //     document.body.classList.add('filter-drawer-opened');
  //     console.log('Added class: filter-drawer-opened');
  //   });
  // } else {
  //   console.warn('.mobile-facets__open-wrapper not found');
  // }

  // // Close filter drawer
  // if (closeBtn) {
  //   closeBtn.addEventListener('click', function (e) {
  //     e.stopPropagation();
  //     document.body.classList.remove('filter-drawer-opened');
  //     console.log('Removed class: filter-drawer-opened (via close button)');
  //   });
  // } else {
  //   console.warn('.mobile-facets__close not found');
  // }

  // // Click outside to close
  // document.addEventListener('click', function (e) {
  //   if(!e.target.closest(".mobile-facets__inner")){
  //     document.body.classList.remove('filter-drawer-opened');
  //   }
  // });

  function checkFooterAndHideMiniNewsLetter(){
    try {
      const footerSection = document.getElementById("shopify-section-footer");
      const stickyMiniSection = document.querySelector(".sticky-sidebar .stay-informed-newsletter-form-mini");
    
      if (!footerSection || !stickyMiniSection) {
        console.warn('One or both required elements not found:', {
          footerSection,
          stickyMiniSection
        });
        return;
      }
    
      const observerFooter = new IntersectionObserver((entries) => {
        try {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              if (window.innerWidth <= 992) {
                stickyMiniSection.style.display = 'none';
                document.body.classList.add("sticky-newsletter-mini-disabled");
              }
            } else {
              if (window.innerWidth <= 992) {
                stickyMiniSection.style.display = '';
                document.body.classList.remove("sticky-newsletter-mini-disabled");
              }
            }
          });
        } catch (entryError) {
          console.error('Error while processing intersection entries:', entryError);
        }
      }, {
        root: null,
        threshold: 0.1
      });
    
      observerFooter.observe(footerSection);
    } catch (err) {
      console.error('IntersectionObserver setup failed:', err);
    }
  }
  
  checkFooterAndHideMiniNewsLetter();
  

  try {
    const mainSection = document.querySelector('.stay-informed-for-blog');
    const miniSection = document.querySelector('.stay-informed-newsletter-form-mini');
  
    if (!mainSection || !miniSection) {
      console.warn('One or both required elements not found:', {
        mainSection,
        miniSection
      });
      return;
    }
  
    const observerMainSection = new IntersectionObserver((entries) => {
      try {
        console.log(entries);
  
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            miniSection.style.display = 'none';
            document.body.classList.add("sticky-newsletter-mini-disabled");
          } else {
            // Uncomment if you want to show it again when out of view
            // miniSection.style.display = '';
          }
        });
      } catch (entryError) {
        console.error('Error while processing intersection entries:', entryError);
      }
    }, {
      root: null,
      threshold: 0.1
    });
  
    observerMainSection.observe(mainSection);
  } catch (err) {
    console.error('IntersectionObserver setup failed:', err);
  }
});

function setupFAQToggle() {
  document.querySelectorAll('.faq-section-mobile .faq-section-question').forEach(item => {
    item.addEventListener('click', function() {
      let answer = this.nextElementSibling;
      let isActive = answer.classList.contains('active');

      document.querySelectorAll('.faq-section-mobile .faq-section-answer').forEach(el => {
        el.style.maxHeight = null;
        el.classList.remove('active');
      });

      document.querySelectorAll('.faq-section-mobile .faq-section-question').forEach(el => {
        el.classList.remove('active');
      });

      if (!isActive) {
        answer.classList.add('active');
        this.classList.add('active');
        
        // Wait a tiny bit to ensure styles are applied
        setTimeout(() => {
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }, 10);
      }
    });
  });
}


// Call on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  setupFAQToggle();
  window.addProductCardClickEvent();
});


window.swiperBreakpointsMultipleBlogSlider = {
  640: {
    slidesPerView: 2.2
  },
  768: {
    slidesPerView: 2.4
  },
  1024: {
    slidesPerView: 2.9
  },
  1200: {
    slidesPerView: 3.44
  },
  1921: {
    slidesPerView: 4
  }
};

window.swiperBreakpointsMainBlogSlider = {
  640: {
    slidesPerView: 1
  }
};

function initializeCardImageSlider() {
  document.querySelectorAll('.product_image_slider').forEach(productImages => {
    new Swiper(productImages, {
      nested: true,
      touchStartPropagation: false,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  });
}

function initializeMainBlogSlider() {
  const sliderEl = document.querySelector('.main-blog-slider');

  if (sliderEl && !sliderEl.swiper) {
    const swiperMainBlogSlider = new Swiper(sliderEl, {
      slidesPerView: 1.178,
      mousewheel: {
        invert: false, // Normal scrolling behavior
        sensitivity: 1, // Adjust trackpad/mousewheel sensitivity
        forceToAxis: true, // Only scroll in the "slide direction"
      },
      spaceBetween: 24,
      pagination: {
        el: ".multiple-blog-pagination",
        clickable: true
      },
      breakpoints: window.swiperBreakpointsMainBlogSlider,
      on: {
        init: function () {
          window.updateFraction(this, '.multiple-blog-fraction');
        },
        slideChange: function () {
          window.updateFraction(this, '.multiple-blog-fraction');
        }
      }
    });

    window.addEventListener("resize", () => {
      window.updateFraction(swiperMainBlogSlider, '.multiple-blog-fraction');
    });
  }
}

function initializeMultipleBlogSlider() {
  const sliderEl = document.querySelector('.multiple-blog-slider');

  if (sliderEl && !sliderEl.swiper) {
    const swiperMultipleBlogSlider = new Swiper(sliderEl, {
      mousewheel: {
        invert: false, // Normal scrolling behavior
        sensitivity: 1, // Adjust trackpad/mousewheel sensitivity
        forceToAxis: true, // Only scroll in the "slide direction"
      },
      slidesPerView: 1.178,
      spaceBetween: 24,
      pagination: {
        el: ".multiple-blog-pagination",
        clickable: true
      },
      breakpoints: window.swiperBreakpointsMultipleBlogSlider,
      on: {
        init: function () {
          window.updateFraction(this, '.multiple-blog-fraction');
        },
        slideChange: function () {
          window.updateFraction(this, '.multiple-blog-fraction');
        }
      }
    });

    window.addEventListener("resize", () => {
      window.updateFraction(swiperMultipleBlogSlider, '.multiple-blog-fraction');
    });
  }
}

function initializeMarqueeSlider() {
  const track = document.querySelector(".marquee-swiper-wrapper");
  const slides = Array.from(document.querySelectorAll(".marquee-swiper-slide"));
  const container = document.querySelector(".marquee-slider");

  if (!track || slides.length === 0 || !container) return;

  let isDragging = false,
      isHovered = false,
      startX = 0,
      velocity = 0,
      currentPosition = 0,
      animationFrameId = null;

  function setupInfiniteLoop() {
    const totalWidth = slides.reduce((acc, slide) => acc + slide.offsetWidth, 0);

    slides.forEach(slide => {
      const cloneEnd = slide.cloneNode(true);
      track.appendChild(cloneEnd);
    });

    slides.forEach(slide => {
      const cloneStart = slide.cloneNode(true);
      track.insertBefore(cloneStart, track.firstChild);
    });

    track.style.transform = `translateX(-${totalWidth}px)`;
    currentPosition = -totalWidth;
  }

  function autoScroll() {
    if (isDragging || isHovered) return;
    const totalWidth = slides.reduce((acc, slide) => acc + slide.offsetWidth, 0) * 2;
    currentPosition -= 0.6;
    if (currentPosition <= -totalWidth) {
      currentPosition = -totalWidth / 2;
    }
    track.style.transform = `translateX(${currentPosition}px)`;
    animationFrameId = requestAnimationFrame(autoScroll);
  }

  function stopAutoScroll() {
    cancelAnimationFrame(animationFrameId);
  }

  function startAutoScroll() {
    stopAutoScroll();
    animationFrameId = requestAnimationFrame(autoScroll);
  }

  function startDragging(e) {
    if(window.innerWidth > 992){
      isDragging = true;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      velocity = 0;
      stopAutoScroll();
    }
  }

  function doDragging(e) {
    if(window.innerWidth > 992){
      if (!isDragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = x - startX;
      startX = x;
      currentPosition += deltaX;
      track.style.transform = `translateX(${currentPosition}px)`;
  
      const totalWidth = slides.reduce((acc, slide) => acc + slide.offsetWidth, 0) * 2;
      if (currentPosition <= -totalWidth || currentPosition >= 0) {
        currentPosition = -totalWidth / 2;
      }
    }
  }

  function stopDragging() {
    if(window.innerWidth > 992){
      if (!isDragging) return;
      isDragging = false;
      startAutoScroll();
    }
  }

  setupInfiniteLoop();
  startAutoScroll();

  track.addEventListener("mousedown", startDragging);
  document.addEventListener("mousemove", doDragging);
  document.addEventListener("mouseup", stopDragging);
  track.addEventListener("touchstart", startDragging);
  document.addEventListener("touchmove", doDragging);
  document.addEventListener("touchend", stopDragging);

  container.addEventListener("mouseenter", () => {
    isHovered = true;
    stopAutoScroll();
  });

  container.addEventListener("mouseleave", () => {
    isHovered = false;
    startAutoScroll();
  });
}

function initializeCompareCarousel() {
  const carouselEl = document.querySelector('.compare-products-swiper');

  if (carouselEl && !carouselEl.swiper) {
    window.swiperBreakpointsReviewsCarousel = {
      500: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1025: { slidesPerView: 4 },
      1440: { slidesPerView: 5 }
    };
    const collectionSwiper = new Swiper(carouselEl, {
      mousewheel: {
        invert: false, // Normal scrolling behavior
        sensitivity: 1, // Adjust trackpad/mousewheel sensitivity
        forceToAxis: true, // Only scroll in the "slide direction"
      },
      slidesPerView: 1.53,
      autoHeight: false,
      pagination: {
        el: ".compare-products-pagination",
        clickable: true
      },
      breakpoints: window.swiperBreakpointsReviewsCarousel,
      on: {
        init: function () {
          window.updateFraction(this, '.compare-products-fraction');
        },
        slideChange: function () {
          // if (window.innerWidth <= 1440) {
          //   window.updateFraction(this, '.compare-products-fraction');
          // }
        },
        paginationUpdate: function () {
            const totalSlidesCount = this.pagination.bullets.length;
            const currentBulletIndex = this.pagination.bullets.findIndex(bullet => bullet.classList.contains('swiper-pagination-bullet-active'));
            const currentStep = currentBulletIndex + 1;
            const fractionEl = this.el.querySelector('.compare-products-fraction');
  
            if (fractionEl) {
              fractionEl.innerHTML = `<strong>${currentStep.toString().padStart(2, '0')}</strong>/${totalSlidesCount.toString().padStart(2, '0')}`;
            }
          
        }
      }
    });

    window.addEventListener("resize", () => {
      window.updateFraction(collectionSwiper, '.compare-products-fraction');
    });
  }
}

function initializeReviewCarousel() {
  const carouselEl = document.querySelector('.review-carousel-container');

  if (carouselEl && !carouselEl.swiper) {
    window.swiperBreakpointsReviewsCarousel = {
      500: { slidesPerView: 1.8, spaceBetween: 24 },
      768: { slidesPerView: 1.2 },
      1025: { slidesPerView: 1.8 },
      1280: { slidesPerView: 2.3 },
      1440: { slidesPerView: 2.78 }
    };
    const collectionSwiper = new Swiper(carouselEl, {
      mousewheel: {
        invert: false, // Normal scrolling behavior
        sensitivity: 1, // Adjust trackpad/mousewheel sensitivity
        forceToAxis: true, // Only scroll in the "slide direction"
      },
      slidesPerView: 1.225,
      spaceBetween: 24,
      autoHeight: false,
      pagination: {
        el: ".review-carousel-pagination",
        clickable: true
      },
      breakpoints: window.swiperBreakpointsReviewsCarousel,
      on: {
        init: function () {
          window.updateFraction(this, '.review-carousel-fraction');
        },
        slideChange: function () {
          // if (window.innerWidth <= 1440) {
          //   window.updateFraction(this, '.review-carousel-fraction');
          // }
        },
        paginationUpdate: function () {
            const totalSlidesCount = this.pagination.bullets.length;
            const currentBulletIndex = this.pagination.bullets.findIndex(bullet => bullet.classList.contains('swiper-pagination-bullet-active'));
            const currentStep = currentBulletIndex + 1;
            const fractionEl = this.el.querySelector('.review-carousel-fraction');
  
            if (fractionEl) {
              fractionEl.innerHTML = `<strong>${currentStep.toString().padStart(2, '0')}</strong>/${totalSlidesCount.toString().padStart(2, '0')}`;
            }
          
        }
      }
    });

    window.addEventListener("resize", () => {
      window.updateFraction(collectionSwiper, '.review-carousel-fraction');
    });
  }
}

function bindCollectionLinks() {
    document.querySelectorAll(".collection__links--filter").forEach(collectionFilter => {
        collectionFilter.querySelectorAll("a").forEach(anchor => {
            anchor.addEventListener("click", function(event) {
                event.preventDefault();
                const url = this.getAttribute("href");
                const facetsSection = document.querySelector("#MainContent");
                const bodyMain = document.querySelector("body");
                facetsSection.classList.add("section_content_update");
                bodyMain.classList.add("filter__update");

                document.querySelectorAll(".collection__links--filter a").forEach(link => {
                    link.classList.remove("active");
                });
    
                document.querySelectorAll(`.collection__links--filter a[href='${url}']`).forEach(link => {
                    link.classList.add("active");
                });

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                      let parser = new DOMParser();
                      let doc = parser.parseFromString(html, "text/html");

                      let content = doc.querySelector("#MainContent");
                      if (content) {
                          document.querySelector("#MainContent").innerHTML = content.innerHTML;
                          window.history.pushState({ path: url }, "", url);
                      }
                      facetsSection.classList.remove("section_content_update");
                      bodyMain.classList.remove("filter__update");

                      bindCollectionLinks();
                      initializeMarqueeSlider();
                      initializeReviewCarousel();
                      initializeMultipleBlogSlider();
                      initializeCardImageSlider();
                      setupFAQToggle();
                      document.body.classList.remove("filter-drawer-opened");
                      
                      // scroll to top after collection is changed
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                      });
                    })
                    .catch(error => {
                        console.error("Error loading collection:", error);
                        facetsSection.classList.remove("section_content_update");
                        bodyMain.classList.remove("filter__update");
                    });
            });
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
  bindCollectionLinks();
  initializeMarqueeSlider();
  initializeReviewCarousel();
  initializeMultipleBlogSlider();
  initializeCompareCarousel();
  initializeCardImageSlider();
  initializeMainBlogSlider();
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("fieldset input").forEach(input => {
    input.addEventListener("focus", function () {
      this.closest("fieldset").classList.add("focused");
    });
    input.addEventListener("blur", function () {
      this.closest("fieldset").classList.remove("focused");
    });
  });
  // document.querySelector("#footersubmitbtn").addEventListener("click", function(event) {
  //   let valid = true;
  //   const firstName = document.getElementById("first-name");
  //   const email = document.getElementById("email");
  //   const firstNameError = document.getElementById("first-name-error");
  //   const emailError = document.getElementById("email-error");
  
  //   firstNameError.classList.add("hide-error");
  //   emailError.classList.add("hide-error");
  //   firstName.classList.remove("error-field");
  //   email.classList.remove("error-field");

  //   if (!firstName.value.trim()) {
  //     firstNameError.classList.remove("hide-error");
  //     firstName.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!email.value.trim() || !email.value.includes("@")) {
  //     emailError.classList.remove("hide-error");
  //     email.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!valid) {
  //     event.preventDefault();
  //   }
  // });

  // document.querySelector("#submitbtn").addEventListener("click", function(event) {
  //   let valid = true;
  //   const firstName = document.getElementById("firstName");
  //   const email = document.getElementById("Email");
  //   const errorMessage = document.getElementById("newsletter__Error--message");
  
  //   firstName.classList.remove("error-field");
  //   email.classList.remove("error-field");
  //   errorMessage.classList.remove("show");
    
  //     if (!firstName.value.trim()) {
  //       firstName.classList.add("error-field");
  //       valid = false;
  //     }
    
  //     if (!email.value.trim() || !email.value.includes("@")) {
  //       email.classList.add("error-field");
  //       valid = false;
  //     }

  //     if (!valid) {
  //       errorMessage.classList.add("show");
  //       event.preventDefault();
  //     }
  //   });


  // document.querySelector("#footersubmitbtn").addEventListener("click", function(event) {
  //   let valid = true;
  //   const firstName = document.getElementById("first-name");
  //   const email = document.getElementById("email");
  //   const firstNameError = document.getElementById("first-name-error");
  //   const emailError = document.getElementById("email-error");

  //   // Reset states
  //   firstNameError.classList.add("hide-error");
  //   emailError.classList.add("hide-error");
  //   firstName.classList.remove("error-field");
  //   email.classList.remove("error-field");

  //   // Validate
  //   if (!firstName.value.trim()) {
  //     firstNameError.classList.remove("hide-error");
  //     firstName.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!email.value.trim() || !email.value.includes("@")) {
  //     emailError.classList.remove("hide-error");
  //     email.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!valid) {
  //     event.preventDefault();
  //   }
  // });

  // document.querySelector("#submitbtn").addEventListener("click", function(event) {
  //   let valid = true;
  //   const firstName = document.getElementById("firstName");
  //   const email = document.getElementById("Email");
  //   const errorMessage = document.getElementById("newsletter__Error--message");

  //   // Reset states
  //   firstName.classList.remove("error-field");
  //   email.classList.remove("error-field");
  //   if (errorMessage) errorMessage.classList.remove("show");

  //   // Validate
  //   if (!firstName.value.trim()) {
  //     firstName.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!email.value.trim() || !email.value.includes("@")) {
  //     email.classList.add("error-field");
  //     valid = false;
  //   }

  //   if (!valid) {
  //     event.preventDefault();
  //     if (errorMessage) errorMessage.classList.add("show");
  //   }
  // });


  // Footer Form Validation
  document.querySelector("#footersubmitbtn").addEventListener("click", function(event) {
      const firstName = document.getElementById("first-name");
      const email = document.getElementById("email");
      const firstNameError = document.getElementById("first-name-error");
      const emailError = document.getElementById("email-error");
  
      let valid = true;
      firstNameError.classList.add("hide-error");
      emailError.classList.add("hide-error");
      firstName.classList.remove("error-field");
      email.classList.remove("error-field");
  
      if (!firstName.value.trim()) {
        firstNameError.classList.remove("hide-error");
        firstName.classList.add("error-field");
        valid = false;
      }
  
      if (!email.value.trim() || !email.value.includes("@")) {
        emailError.classList.remove("hide-error");
        email.classList.add("error-field");
        valid = false;
      }
  
      if (!valid) {
        event.preventDefault(); // Only prevent if invalid
      }
      // else: do NOT modify form or action — let Shopify handle it
    });

  // Newsletter Section Form Validation
  document.querySelector(".custom-newsletter-section #submitbtn")?.addEventListener("click", function(event) {
      const firstName = document.querySelector(".custom-newsletter-section #firstName");
      const email = document.querySelector(".custom-newsletter-section #Email");
      const errorMessage = document.querySelector(".custom-newsletter-section #newsletter__Error--message");
  
      let valid = true;
      firstName.classList.remove("error-field");
      email.classList.remove("error-field");
      errorMessage?.classList.remove("show");
  
      if (!firstName.value.trim()) {
        firstName.classList.add("error-field");
        valid = false;
      }
  
      if (!email.value.trim() || !email.value.includes("@")) {
        email.classList.add("error-field");
        valid = false;
      }
  
      if (!valid) {
        event.preventDefault(); // Only block if validation fails
        errorMessage?.classList.add("show");
      }
      // else: let the form submit normally
    });
  
});
 
// Only run this script if the page contains the target class (e.g., 'collection-page')
if (document.body.classList.contains('collection-page')) {
  const openButton = document.querySelector('.mobile-facets__open');
  const closeButton = document.querySelector('.mobile-facets__close');
  if (openButton) {
    openButton.addEventListener('click', function () {
      document.body.classList.add('mobile-facets-open');
    });
  } else {
    console.error("'.mobile-facets__open' button not found.");
  }
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      document.body.classList.remove('mobile-facets-open');
    });
  } else {
    console.error("'.mobile-facets__close' button not found.");
  }
}

document.addEventListener('DOMContentLoaded', () => {

  // Event listener for size checkboxes
  const sizeCheckboxes = document.querySelectorAll('.size-checkbox');

  sizeCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', (event) => {
      const selectedSizes = Array.from(sizeCheckboxes)
        .filter((cb) => cb.checked) // Get only checked checkboxes
        .map((cb) => cb.value); // Extract their values

      // Example action: Log the selected sizes
      console.log('Selected Sizes:', selectedSizes);

      // If you need this information in a hidden input to submit with the form:
      const sizeInput = document.querySelector('input[name="selected_size"]');
      sizeInput.value = selectedSizes.join(',');
    });
  });
  

  const url = window.location.href;

  // Contact Us Page Stay Informed Form 
  if (url.includes('?contact_posted=true#contact_form')) {
    history.replaceState(null, null, window.location.pathname + '?contact_posted=true');
    const target = document.querySelector('#stay-informed-form');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Newsletter Section Form 
  if (url.includes('?customer_posted=true#newsletter-form')) {
    history.replaceState(null, null, window.location.pathname + '?customer_posted=true');
    const target = document.querySelector('.custom-newsletter');
    const thanksMessage = document.querySelector('#newsletter-form .thanks__message');
    thanksMessage.style.display = 'block';
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Footer Newsletter Form 
  if (url.includes('?customer_posted=true#footer-newsletter-form')) {
    history.replaceState(null, null, window.location.pathname + '?customer_posted=true');
    const target = document.querySelector('.footer-main');
    const footerthanksMessage = document.querySelector('#footer-newsletter-form .thanks__message');
    footerthanksMessage.style.display = 'block';
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }

}); 

// window.matchHeightForFindYourCleanSupplements = function(){
  
//   // Function to match heights
//   function matchHeight() {
//     // Reset heights first to get accurate measurements
//     document.querySelectorAll(".featured-collections-tabs .tab-content .swiper-slide").forEach(slide => {
//       slide.style.height = 'auto';
//     });
    
//     // Group elements by their parent tab content
//     const tabContents = document.querySelectorAll(".featured-collections-tabs .tab-content");
    
//     tabContents.forEach(tabContent => {
//       const slides = tabContent.querySelectorAll(".swiper-slide");
      
//       if (slides.length === 0) return;
      
//       // Find tallest element in this tab content
//       let maxHeight = 0;
//       slides.forEach(slide => {
//         const height = slide.offsetHeight;
//         if (height > maxHeight) {
//           maxHeight = height;
//         }
//       });
      
//       // Set all elements to the tallest height
//       slides.forEach(slide => {
//         slide.style.height = maxHeight + 'px';
//       });
      
//       // Optional: Match specific child elements within slides
//       matchChildElements(slides, '.product-title');
//       matchChildElements(slides, '.product-price');
//       matchChildElements(slides, '.product-description');
//     });
//   }
  
//   // Helper function to match heights of specific child elements
//   function matchChildElements(slides, selector) {
//     let maxHeight = 0;
    
//     // Find max height
//     slides.forEach(slide => {
//       const element = slide.querySelector(selector);
//       if (element) {
//         // Reset height first to get true height
//         element.style.height = 'auto';
//         const height = element.offsetHeight;
//         if (height > maxHeight) {
//           maxHeight = height;
//         }
//       }
//     });
    
//     // Apply max height to all matching elements
//     if (maxHeight > 0) {
//       slides.forEach(slide => {
//         const element = slide.querySelector(selector);
//         if (element) {
//           element.style.height = maxHeight + 'px';
//         }
//       });
//     }
//   }
  
//   // Initial match height
//   matchHeight();
  
//   // Match heights on window resize
//   window.addEventListener('resize', debounce(matchHeight, 250));
  
//   // Match heights when tabs change
//   document.querySelectorAll('.featured-collections-tabs .tab-trigger').forEach(tab => {
//     tab.addEventListener('click', function() {
//       // Allow time for the new tab content to be visible
//       setTimeout(matchHeight, 100);
//     });
//   });
  
//   // Match heights after images load (which can affect heights)
//   document.querySelectorAll(".featured-collections-tabs .tab-content img").forEach(img => {
//     img.addEventListener('load', debounce(matchHeight, 100));
//   });
  
//   // Debounce function to prevent excessive calls
//   function debounce(func, wait) {
//     let timeout;
//     return function() {
//       const context = this;
//       const args = arguments;
//       clearTimeout(timeout);
//       timeout = setTimeout(() => func.apply(context, args), wait);
//     };
//   }
  
//   // If using Swiper, make sure to call matchHeight after swiper initialization
//   if (typeof Swiper !== 'undefined') {
//     document.querySelectorAll('.featured-collections-tabs .swiper').forEach(swiperEl => {
//       if (swiperEl.swiper) {
//         swiperEl.swiper.on('imagesReady', matchHeight);
//         swiperEl.swiper.on('resize', matchHeight);
//       }
//     });
//   }

// }


// window.matchElementsHeight = function(selector) {
//   // Get all elements matching the selector
//   const elements = document.querySelectorAll(selector);
  
//   if (!elements.length) {
//     console.warn(`No elements found matching selector: ${selector}`);
//     return;
//   }

//   // Reset any previously set heights
//   elements.forEach(element => {
//     element.style.height = 'auto';
//   });

//   // Find the maximum height
//   let maxHeight = 0;
//   elements.forEach(element => {
//     const height = element.offsetHeight;
//     maxHeight = Math.max(maxHeight, height);
//   });

//   // Apply the maximum height to all elements
//   elements.forEach(element => {
//     element.style.height = `${maxHeight}px`;
//   });
// }; 

window.matchElementsHeight = function(selectorOrElements) {
  // Accept selector string or an array/NodeList of elements
  let elements;

  if (typeof selectorOrElements === 'string') {
    elements = document.querySelectorAll(selectorOrElements);
  } else if (selectorOrElements instanceof NodeList || Array.isArray(selectorOrElements)) {
    elements = selectorOrElements;
  } else {
    console.warn('Invalid argument passed to matchElementsHeight');
    return;
  }

  if (!elements.length) {
    console.warn('No elements to match height for');
    return;
  }

  // Reset heights
  elements.forEach(element => {
    element.style.height = 'auto';
  });

  // Find max height
  let maxHeight = 0;
  elements.forEach(element => {
    const height = element.offsetHeight;
    maxHeight = Math.max(maxHeight, height);
  });

  // Apply max height
  elements.forEach(element => {
    element.style.height = `${maxHeight}px`;
  });
};

// Add resize Elements in this function
window.MatchHeightOfElementsProvided = function() {
  window.matchElementsHeight(".featured-collections-tabs .product_image_slider");
  window.matchElementsHeight(".featured-collections-tabs .product-title");
  window.matchElementsHeight(".compare-products-container .product-title");
  window.matchElementsHeight(".complete-stack-container .product-title")
  window.matchElementsHeight(".complete-stack-product-item .product-content-wrapper .product-description");
  window.matchElementsHeight(".shop-by-goal .block-header");
  window.matchElementsHeight(".goal-product-carousel .product-title");
  
  let ElArray = [];
  document.querySelectorAll(".compare-product-feature-list").forEach(container => {
    container.querySelectorAll(".feature-list-item").forEach((el, index) => {
      if (!ElArray[index]) {
        ElArray[index] = [];
      }
      ElArray[index].push(el);
  
      // Now this will work as intended
      window.matchElementsHeight(ElArray[index]);
    });
  });
}

let resizeTimer;
window.addEventListener("resize", function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if (typeof window.MatchHeightOfElementsProvided === "function") {
      window.MatchHeightOfElementsProvided();
    }
  }, 200);
});


window.filtersChanged = function() {
  initializeCardImageSlider();
}

window.addProductCardClickEvent = function() {
  document.querySelectorAll(".product-grid-item").forEach(el => {
    if (!el.classList.contains("event-added")) {
      el.classList.add("event-added");

      el.addEventListener("click", function(e) {
        const isSwiperButton = e.target.closest('.swiper-button-prev, .swiper-button-next');
        if (isSwiperButton) return;

        const link = el.querySelector("a.product-title");
        if (!link) return;

        // Avoid double handling if the anchor itself was clicked
        if (e.target.closest("a.product-title")) return;
        if (e.target.closest("quick-view-custom")) return;

        // Clone and dispatch the original event to the anchor
        const clickEvent = new MouseEvent(e.type, e);
        link.dispatchEvent(clickEvent);
      });
    }
  });
};

// Observe changes in the DOM to auto-trigger the above
const observerProductGridItem = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length) {
      // Only run when actual new elements are added
      window.addProductCardClickEvent();
      break;
    }
  }
});

// Start observing the whole document
observerProductGridItem.observe(document.body, {
  childList: true,
  subtree: true
});

// Run once initially on page load
window.addProductCardClickEvent();

window.sliderInSliderManager = function() {
  let startX = 0;
  let startY = 0;
  
  document.addEventListener('touchstart', function (e) {
    const innerSwiper = e.target.closest('.swiper-initialized');
    const outerSwiper = innerSwiper?.parentElement?.closest('.swiper-initialized');
  
    if (innerSwiper && outerSwiper && innerSwiper !== outerSwiper) {
      const outerInstance = outerSwiper.swiper;
      if (outerInstance) {
        outerInstance.allowTouchMove = false;
      }
  
      // Store touch start position
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
  
      innerSwiper.addEventListener('touchmove', handleInnerTouchMove, { passive: false });
    }
  }, { passive: true });
  
  document.addEventListener('touchend', function () {
    // Re-enable outer swiper movement
    document.querySelectorAll('.swiper-initialized').forEach(el => {
      if (el.swiper) el.swiper.allowTouchMove = true;
      el.removeEventListener('touchmove', handleInnerTouchMove);
    });
  });
  
  function handleInnerTouchMove(e) {
    const touch = e.touches[0];
    const dx = Math.abs(touch.clientX - startX);
    const dy = Math.abs(touch.clientY - startY);
  
    if (dx > dy) {
      // Horizontal swipe: prevent propagation to parent swiper
      e.stopPropagation();
      e.preventDefault();
    }
    // If dy > dx, it's vertical: let it scroll normally (no preventDefault)
  }
}
// window.sliderInSliderManager();



// window.swipeSliderOnMouseScroll = function() {
//   let isPointerOverSwiper = false;
//   let scrollThrottle = false;
  
//   // Watch for pointer entering/exiting swiper sliders
//   document.querySelectorAll('.swiper-initialized').forEach(swiperEl => {
//     swiperEl.addEventListener('mouseenter', () => {
//       isPointerOverSwiper = swiperEl;
//     });
  
//     swiperEl.addEventListener('mouseleave', () => {
//       isPointerOverSwiper = false;
//     });
//   });
  
//   // Global wheel handler
//   window.addEventListener('wheel', (event) => {
//     if (!isPointerOverSwiper || !isPointerOverSwiper.swiper) return;
  
//     if (scrollThrottle) {
//       event.preventDefault(); // still block scrolling even if throttled
//       return;
//     }
  
//     const swiper = isPointerOverSwiper.swiper;
//     const scrollDir = event.deltaY > 0 ? 'down' : 'up';
  
//     event.preventDefault(); // 🚫 Block page scroll
  
//     if (scrollDir === 'down') {
//       swiper.slideNext();
//     } else {
//       swiper.slidePrev();
//     }
  
//     scrollThrottle = true;
//     setTimeout(() => scrollThrottle = false, 200);
//   }, { passive: false });

// }


// --- CONFIGURABLES ---
const INACTIVITY_LS_KEY = 'hide_sub_upgrade_popup_until_ls';
const INACTIVITY_TIMEOUT = 1800; // seconds (for demo: 30 seconds, prod: 1800 for 30 minutes)
const LOG_TIMER = false; // Set true to log session timer, false to not

// --- Sliding Inactivity LocalStorage Helpers ---
function setInactivityUntilLS(seconds) {
  localStorage.setItem(INACTIVITY_LS_KEY, (Date.now() + seconds*1000).toString());
}
function isInactivityExpired() {
  const val = localStorage.getItem(INACTIVITY_LS_KEY);
  return !val || Date.now() > Number(val);
}
function getInactivityExpires() {
  const val = localStorage.getItem(INACTIVITY_LS_KEY);
  return val ? Number(val) : null;
}
function formatMs(ms) {
  let t = Math.max(0, Math.floor(ms/1000)), h=Math.floor((t%3600)/3600), m=Math.floor((t%3600)/60), s=t%60;
  return (h ? String(h).padStart(2,'0')+':' : '') + String(m).padStart(2,'0') + ':' + String(s).padStart(2,'0');
}

// --- TIMER LOGGING ---
let inactivityLogInterval = null;
function startInactivityLog() {
  if (!LOG_TIMER) return;
  stopInactivityLog();
  inactivityLogInterval = setInterval(() => {
    const exp = getInactivityExpires();
    if (exp && exp > Date.now()) {
      console.log('Upgrade popup session time left: ' + formatMs(exp - Date.now()));
    } else {
      stopInactivityLog();
    }
  }, 1000);
}
function stopInactivityLog() {
  if (inactivityLogInterval) { clearInterval(inactivityLogInterval); inactivityLogInterval = null; }
}

// --- Is Popup Open Utility ---
function isPopupOpen() {
  return !!window.subUpgradeModal && window.subUpgradeModal.style.display === "flex";
}

// --- SLIDING SESSION: Interactions ---
function extendSessionOnInteraction() {
  // Only extend if the popup is HIDING (not shown) and the timer is active
  if (!isPopupOpen() && !isInactivityExpired()) {
    setInactivityUntilLS(INACTIVITY_TIMEOUT);
    if (LOG_TIMER) {
      const exp = getInactivityExpires();
      if (exp && exp > Date.now()) {
        console.log(
          '[EXTEND] Upgrade popup session time reset to: ' + formatMs(exp - Date.now())
        );
      }
    }
  }
}
['click','mousemove','keydown','scroll','touchstart'].forEach(evt =>
  window.addEventListener(evt, extendSessionOnInteraction, {passive:true})
);
// Also refresh when coming back to tab
document.addEventListener("visibilitychange", function () {
  if (!document.hidden) extendSessionOnInteraction();
});

// --- Declarations ---
window.upgradeToSubscriptionDeclaration = function() {
  window.subUpgradeModal = document.getElementById("subUpgradeModal");
  window.closeSubUpgradeBtn = document.querySelector(".sub-upgrade-close-btn");

  if (!window.subUpgradeModal || !window.closeSubUpgradeBtn) {
    console.warn("Subscription upgrade modal elements not found.");
    return;
  }

  // Hide popup for inactivity timeout using localStorage on close button click
  window.closeSubUpgradeBtn.onclick = function () {
    window.subUpgradeModal.style.display = "none";
    document.body.classList.remove('sub-upgrade-modal-open');
    
    setInactivityUntilLS(INACTIVITY_TIMEOUT);
    startInactivityLog();
  };

  // Hide popup for inactivity timeout using localStorage if user clicks outside popup (on overlay)
  window.subUpgradeModal.addEventListener('click', function (event) {
    if (event.target === window.subUpgradeModal) {
      window.subUpgradeModal.style.display = "none";
      document.body.classList.remove('sub-upgrade-modal-open');
      setInactivityUntilLS(INACTIVITY_TIMEOUT);
      startInactivityLog();
    }
  });
};

window.upgradeToSubscription = function (key) {
  try {
    // Prevent showing popup if inactivity LS exists and is not expired
    if (!isInactivityExpired()) {
      startInactivityLog();
      return;
    }

    // Check if a one-time purchase option is selected
    var oneTimeChecked = document.querySelector('.product-main-section .skio-plan-picker input.skio-group-input[skio-one-time]:checked');
    if (!oneTimeChecked) return;

    if (!window.subUpgradeModal) throw new Error('subUpgradeModal not found');

    window.subUpgradeModal.style.display = "flex";
    document.body.classList.add('sub-upgrade-modal-open');
    stopInactivityLog(); // stop timer log when popup is visible

    const switchBtn = window.subUpgradeModal.querySelector('[switch-to-subscription]');
    const cancelBtn = window.subUpgradeModal.querySelector('[add-one-time-only]');
    const closeBtn = window.closeSubUpgradeBtn;

    function cleanup() {
      switchBtn.removeEventListener('click', onSwitch);
      cancelBtn.removeEventListener('click', onCancel);
      closeBtn.removeEventListener('click', onCancel);
      window.subUpgradeModal.style.display = "none";
      document.body.classList.remove('sub-upgrade-modal-open');
      setInactivityUntilLS(INACTIVITY_TIMEOUT);
      startInactivityLog();
    }

    function onSwitch() {
      try {
        const upsellBtn = document
          .querySelector(`#cart-menu [data-id="${key}"]`)
          ?.querySelector("skio-cart-upsell")
          ?.shadowRoot
          ?.querySelector("button.skio-cart-upgrade");
        if (upsellBtn) {
          const evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });
          upsellBtn.dispatchEvent(evt);
        }
      } catch (e) {
        console.error("Failed to trigger cart-upsell upgrade button.", e);
      }
      cleanup();
    }

    function onCancel() {
      cleanup();
    }

    switchBtn.addEventListener('click', onSwitch);
    cancelBtn.addEventListener('click', onCancel);
    closeBtn.addEventListener('click', onCancel);

  } catch (error) {
    console.error("Error in upgradeToSubscription:", error);
  }
};

if (LOG_TIMER) {
  const exp = getInactivityExpires();
  if (exp && exp > Date.now()) {
    console.log('[LOAD] Upgrade popup session time left: ' + formatMs(exp - Date.now()));
    startInactivityLog();
  }
}

class QuickViewCustom extends HTMLElement {
  constructor() {
    super();
    this.openQvDrawer = this.openQvDrawer.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.handleVariantFormRadio = this.handleVariantFormRadio.bind(this);
    this.handleVariantFormSelect = this.handleVariantFormSelect.bind(this);
    this.handleVariantFormSubmit = this.handleVariantFormSubmit.bind(this);
  }

  connectedCallback() {
    this.qvBtn = this.querySelector(".open-drawer");
    if (this.qvBtn) {
      this.qvBtn.addEventListener("click", this.openQvDrawer);
    }
    console.log("Custom element added to page.");
  }

  openQvDrawer(e) {
    e.preventDefault();
    let buttonEl = e.currentTarget;
    this.fetchQvProductDetails(buttonEl.dataset.productHandle);
  }

  fetchQvProductDetails(handle) {
    const quickViewUrl = `/products/${handle}?view=quick-view`;
    fetch(quickViewUrl, { credentials: 'include' })
      .then(response => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.text();
      })
      .then(html => {
        document.querySelector('.inject-dynamic-product-details').innerHTML = html
        document.querySelector(".xt-quiz-option-cart").classList.add("xactive");
        this.addQuickViewEvents();
      })
      .catch(err => {
        console.error("Failed to fetch quick view:", err);
      });
  }

  // Formerly handleRadioChange function
  handleRadioChange(event) {
    const radio = event.target;
    const drawer = radio.closest(".xproduct");
    if (drawer) {
      drawer.querySelectorAll(".freq-box").forEach((box) => box.classList.remove("active"));
      radio.closest(".freq-box").classList.add("active");
    }
  }

  addQuickViewEvents() {
    // Handle open-drawer button
    // document.querySelectorAll(".open-drawer").forEach(button => {
    //   button.addEventListener("click", () => {
    //     const productId = button.dataset.productId;
    //     document.querySelectorAll(".xproduct").forEach(product => product.style.display = "none");
    //     document.querySelector(".xt-quiz-option-cart").classList.add("xactive");
    //     const popup = document.getElementById(`variant-drawer-${productId}`);
    //     if (popup) {
    //       popup.style.display = "flex";
    //       const activeRadio = popup.querySelector(".freq-radio:checked");
    //       if (activeRadio) {
    //         activeRadio.closest(".freq-box").classList.add("active");
    //       }
    //       popup.querySelectorAll(".freq-radio").forEach(radio => {
    //         radio.addEventListener("change", this.handleRadioChange);
    //       });
    //     }
    //   });
    // });

    // Add listeners to variant forms
    document.querySelectorAll(".variant-form").forEach(form => {
      const productId = form.dataset.productId;
      const variantDataElement = document.getElementById(`product-variants-${productId}`);
      if (!variantDataElement) return;
      const variants = JSON.parse(variantDataElement.textContent);

      // Listen for option changes on radios
      form.querySelectorAll(".product-option-radio").forEach(input => {
        input.addEventListener("change", (ev) => this.handleVariantFormRadio(ev, form, variants));
      });
      // Listen for option changes on selects
      form.querySelectorAll(".product-option-dropdown").forEach(input => {
        input.addEventListener("change", (ev) => this.handleVariantFormSelect(ev, form, variants));
      });
      // Set initial state for selects
      form.querySelectorAll(".product-option-dropdown").forEach(input => {
        this.handleVariantFormSelect(null, form, variants);
      });
      // Form submit
      form.addEventListener("submit", (ev) => this.handleVariantFormSubmit(ev, form));
    });
  }

  // Handles option radio change
  handleVariantFormRadio(event, form, variants) {
    // Remove 'active' from all labels
    form.querySelectorAll(".size").forEach(label => label.classList.remove("active"));
    if (event && event.target.checked) {
      event.target.closest(".size").classList.add("active");
    }
    this.updateDropdownAvailability(form, variants);
    this.updateVariantId(form, variants);
  }

  // Handles option select change
  handleVariantFormSelect(event, form, variants) {
    this.updateVariantId(form, variants);
  }

  updateDropdownAvailability(form, variants) {
    let selectedOptions = [];
    // Get dropdown selected values
    form.querySelectorAll(".product-option-dropdown").forEach(select => {
      selectedOptions[select.dataset.optionIndex] = select.value;
    });
    // Get checked radios
    form.querySelectorAll(".product-option-radio:checked").forEach(radio => {
      selectedOptions[radio.dataset.optionIndex] = radio.value;
    });

    let availableOptions = {};

    form.querySelectorAll(".product-option-dropdown").forEach(select => {
      let optionIndex = select.dataset.optionIndex;
      let availableValues = [...new Set(
        variants
          .filter(v => v.options.slice(0, optionIndex)
            .every((opt, idx) => selectedOptions[idx] === opt))
          .map(v => v.options[optionIndex])
      )];
      availableOptions[optionIndex] = availableValues;
      let firstAvailableOption = null;
      select.querySelectorAll("option").forEach(option => {
        if (availableValues.includes(option.value)) {
          option.disabled = false;
          option.style.display = "block";
          if (!firstAvailableOption) firstAvailableOption = option;
        } else {
          option.disabled = true;
          option.style.display = "none";
          option.removeAttribute("selected");
        }
      });
      if (firstAvailableOption) {
        select.value = firstAvailableOption.value;
        firstAvailableOption.setAttribute("selected", "selected");
      }
    });
  }

  // Handles variant updates (name unchanged)
  updateVariantId(form, variants) {
    let selectedOptions = [];
    form.querySelectorAll(".product-option-dropdown").forEach(select => {
      selectedOptions[select.dataset.optionIndex] = select.value;
    });
    form.querySelectorAll(".product-option-radio:checked").forEach(radio => {
      selectedOptions[radio.dataset.optionIndex] = radio.value;
    });
    let matchedVariant = variants.find(v => {
      return v.options.every((opt, idx) => opt === selectedOptions[idx]);
    });

    if (matchedVariant) {
      const variantDrawer = document.getElementById(`variant-drawer-${matchedVariant.featured_image.product_id}`);
      if (variantDrawer) {
        const images = variantDrawer.querySelectorAll(".img img");
        if(images.length > 1) {
          images.forEach(img => {
            if (img.dataset.variantId == matchedVariant.id) {
              img.style.display = "block";
            } else {
              img.style.display = "none";
            }
          });
        }
      }
    }
    const variantIdInput = form.querySelector(".selected-variant-id");
    if (matchedVariant && variantIdInput) {
      variantIdInput.value = matchedVariant.id;
    }
    const priceField = form.querySelector(".product-price");
    const compareAtPriceField = form.querySelector(".product-compare-price");
    const oneTimePriceField = form.querySelector(".one-time-price");
    if (matchedVariant) {
      const sellingPlan = matchedVariant.selling_plan_allocations && matchedVariant.selling_plan_allocations[0];
      if (sellingPlan) {
        const price = sellingPlan.price / 100;
        const compareAtPrice = sellingPlan.compare_at_price ? sellingPlan.compare_at_price / 100 : null;
        const oneTimePrice = matchedVariant.price / 100;
        if (oneTimePriceField) oneTimePriceField.innerText = `$${oneTimePrice.toFixed(2)}`;
        if (priceField) priceField.innerText = `$${price.toFixed(2)}`;
        if (compareAtPriceField) {
          if (compareAtPrice) {
            compareAtPriceField.innerText = `$${compareAtPrice.toFixed(2)}`;
            compareAtPriceField.style.display = 'block';
          } else {
            compareAtPriceField.style.display = 'none';
          }
        }
      } else {
        const price = matchedVariant.price / 100;
        const compareAtPrice = matchedVariant.compare_at_price ? matchedVariant.compare_at_price / 100 : null;
        if (priceField) priceField.innerText = `$${price.toFixed(2)}`;
        if (compareAtPriceField) {
          if (compareAtPrice) {
            compareAtPriceField.innerText = `$${compareAtPrice.toFixed(2)}`;
            compareAtPriceField.style.display = 'block';
          } else {
            compareAtPriceField.style.display = 'none';
          }
        }
      }
    }
  }

  // Handles form submit event
  handleVariantFormSubmit(event, form) {
    event.preventDefault();
    let formData = new FormData();
    let variantId = form.querySelector(".selected-variant-id")?.value;
    if (!variantId) {
      alert("Please select all required options.");
      return;
    }
    formData.append("id", variantId);
    formData.append("quantity", 1);

    const planFreq = form.querySelector("[name='plan-freq']:checked")?.value;
    if (planFreq === "subscription") {
      let sellingPlanSelect = form.querySelector("[name='selling_plan']");
      if (sellingPlanSelect && sellingPlanSelect.value) {
        formData.append("selling_plan", sellingPlanSelect.value);
      }
    }

    let addToCartButton = form.querySelector("button[type='submit']");
    let productId = form.querySelector(".btn")?.getAttribute("data-product-id");
    let originalButtonText = addToCartButton.innerText;
    let checkoutBtn = document.getElementById('sticky-checkout');
    let cartCount = document.getElementById('sticky-cart-count');
    // if (productId) {
    //   let relatedButtons = document.querySelectorAll(`.btn-${productId}`);
    //   relatedButtons.forEach(btn => btn.innerText = "Adding...");
    // }

    fetch("/cart/add.js", {
      method: "POST",
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      $.getJSON('/cart.js', function(cart) {
        if (cart.item_count < 1) {
          $('#cart-count').html("");
          checkoutBtn.style.display = "none";
        } else {
          $('#cart-count').html("<number class='number'>" + cart.item_count + "</number>");
          checkoutBtn.style.display = "flex";
          $('#sticky-cart-count').html("<number class='number'>" + cart.item_count + "</number> " + (cart.item_count === 1 ? "item" : "items"));
        }
      });

      // if (productId) {
      //   let relatedButtons = document.querySelectorAll(`.btn-${productId}`);
      //   relatedButtons.forEach(btn => {
      //     btn.classList.add("added");
      //     btn.innerHTML = `Added to Cart <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="20" height="20" rx="10" fill="#1DB31B"/><path d="M8.42774 14.3337L4.66666 10.1492L5.50714 9.18306L8.42774 12.4013L14.4701 5.66699L15.3333 6.63318L8.42774 14.3337Z" fill="white"/></svg>`;
      //   });
      // }
      document.querySelector(".xt-quiz-option-cart").classList.remove("xactive");
      document.querySelectorAll(".xproduct").forEach(product => product.style.display = "none");
      setTimeout(function(){
        openCartMenu();
      }, 1000);
    })
    .catch(error => {
      console.error("Error adding to cart:", error);
    });
  }

  disconnectedCallback() {
    if (this.qvBtn) {
      this.qvBtn.removeEventListener("click", this.openQvDrawer);
    }
    console.log("Custom element removed from page.");
  }
}

customElements.define("quick-view-custom", QuickViewCustom);

// prevent default Quiz Submit form
const waitForForm = setInterval(() => {
  if (document.querySelector(".klaviyo-quiz-form-custom")) {
      document.querySelectorAll(".klaviyo-quiz-form-custom").forEach(el => {
        el.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
          }
        })
      });
    clearInterval(waitForForm);
  }
}, 200);